import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: { input: any; output: any };
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: any; output: any };
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library. The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: { input: string; output: string };
  FeatureFlag: { input: string; output: string };
};

export type AddressDetails = {
  __typename?: "AddressDetails";
  city: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  houseNumber: Scalars["String"]["output"];
  postalCode: Scalars["String"]["output"];
  street: Scalars["String"]["output"];
};

export type AddressInput = {
  city: Scalars["String"]["input"];
  country: Scalars["String"]["input"];
  houseNumber: Scalars["String"]["input"];
  postalCode: Scalars["String"]["input"];
  street: Scalars["String"]["input"];
};

export type BankDetails = {
  __typename?: "BankDetails";
  accountOwner: Scalars["String"]["output"];
  bic?: Maybe<Scalars["String"]["output"]>;
  iban: Scalars["String"]["output"];
};

export enum CurrentUserQueryError {
  UserNotLoggedIn = "USER_NOT_LOGGED_IN",
}

export type CurrentUserQueryResult = {
  __typename?: "CurrentUserQueryResult";
  errors: Array<CurrentUserQueryError>;
  success: Scalars["Boolean"]["output"];
  user?: Maybe<User>;
};

export type Customer = {
  __typename?: "Customer";
  /** User visible customer number (coming from SAP) */
  customerNumber?: Maybe<Scalars["String"]["output"]>;
  /** Salesforce internal ID of the customer (Account ID) */
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  name2?: Maybe<Scalars["String"]["output"]>;
  serviceSubscriptions: Array<ServiceSubscription>;
};

export type CustomerManagementCustomer = {
  __typename?: "CustomerManagementCustomer";
  address?: Maybe<CustomerManagementCustomerAddress>;
  /** User visible customer number (coming from SAP) */
  customerNumber?: Maybe<Scalars["String"]["output"]>;
  /** Salesforce internal ID of the customer (Account ID) */
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  name2?: Maybe<Scalars["String"]["output"]>;
  serviceSubscriptions: Array<CustomerManagementService>;
};

export type CustomerManagementCustomerAddress = {
  __typename?: "CustomerManagementCustomerAddress";
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  /** Street name including house number */
  street?: Maybe<Scalars["String"]["output"]>;
};

export type CustomerManagementInvitation = {
  __typename?: "CustomerManagementInvitation";
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  invitationLink: Scalars["String"]["output"];
  maximumRegistrations: Scalars["Int"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  needsReview: Scalars["Boolean"]["output"];
  registrations: Array<CustomerManagementRegistration>;
  servicesWithRoles: Array<CustomerManagementService>;
  status: CustomerManagementInvitationState;
  validUntil: Scalars["Date"]["output"];
};

export enum CustomerManagementInvitationState {
  Active = "ACTIVE",
  Disabled = "DISABLED",
  Expired = "EXPIRED",
}

export type CustomerManagementInvitationsPage = {
  __typename?: "CustomerManagementInvitationsPage";
  invitations: Array<CustomerManagementInvitation>;
  paginationMetadata: PaginationMetadata;
};

export enum CustomerManagementRegisterUserMutationError {
  EmailTaken = "EMAIL_TAKEN",
  InternalError = "INTERNAL_ERROR",
  InvalidInvitation = "INVALID_INVITATION",
  MultipleContactsFound = "MULTIPLE_CONTACTS_FOUND",
  Unauthorized = "UNAUTHORIZED",
  UserAlreadyRegistered = "USER_ALREADY_REGISTERED",
  UserDataDiffers = "USER_DATA_DIFFERS",
}

export type CustomerManagementRegisterUserMutationResult = {
  __typename?: "CustomerManagementRegisterUserMutationResult";
  caseNumber?: Maybe<Scalars["String"]["output"]>;
  errors: Array<CustomerManagementRegisterUserMutationError>;
  registrationFinished: Scalars["Boolean"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type CustomerManagementRegistration = {
  __typename?: "CustomerManagementRegistration";
  caseNumber?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
  salutation?: Maybe<Salutation>;
  status: CustomerManagementRegistrationState;
  updatedAt: Scalars["DateTime"]["output"];
};

export type CustomerManagementRegistrationDataInput = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  invitationId: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  newsletterConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
  salutation: RegistrationSalutationInput;
};

export enum CustomerManagementRegistrationReviewOptions {
  Approve = "APPROVE",
  Reject = "REJECT",
}

export enum CustomerManagementRegistrationState {
  Approved = "APPROVED",
  Failed = "FAILED",
  Pending = "PENDING",
  Rejected = "REJECTED",
}

export enum CustomerManagementReviewRegistrationError {
  InternalError = "INTERNAL_ERROR",
  MultipleContactsFound = "MULTIPLE_CONTACTS_FOUND",
  Unauthorized = "UNAUTHORIZED",
  UserAlreadyRegistered = "USER_ALREADY_REGISTERED",
  UserDataDiffers = "USER_DATA_DIFFERS",
}

export type CustomerManagementReviewRegistrationResult = {
  __typename?: "CustomerManagementReviewRegistrationResult";
  caseNumber?: Maybe<Scalars["String"]["output"]>;
  errors: Array<CustomerManagementReviewRegistrationError>;
  invitationResult?: Maybe<InvitationResult>;
  success: Scalars["Boolean"]["output"];
};

export type CustomerManagementService = {
  __typename?: "CustomerManagementService";
  id: ServiceSubscription;
  name: Scalars["String"]["output"];
  serviceRoles: Array<CustomerManagementServiceRole>;
};

export type CustomerManagementServiceRole = {
  __typename?: "CustomerManagementServiceRole";
  id: ServiceRole;
  name: Scalars["String"]["output"];
};

export type CustomerManagementSupportCaseFilterInput = {
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
};

export enum CustomerManagementUpdateUserPermissionsError {
  CannotRemoveOwnAccountManagerPermissions = "CANNOT_REMOVE_OWN_ACCOUNT_MANAGER_PERMISSIONS",
  InternalError = "INTERNAL_ERROR",
  Unauthorized = "UNAUTHORIZED",
}

export type CustomerManagementUpdateUserPermissionsResult = {
  __typename?: "CustomerManagementUpdateUserPermissionsResult";
  errors: Array<CustomerManagementUpdateUserPermissionsError>;
  success: Scalars["Boolean"]["output"];
};

export type CustomerManagementUserData = {
  __typename?: "CustomerManagementUserData";
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
  registrationLink?: Maybe<Scalars["String"]["output"]>;
  salutation?: Maybe<Salutation>;
  servicesWithRoles: Array<CustomerManagementService>;
  state: CustomerManagementUserState;
};

export type CustomerManagementUserDataFilterInput = {
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  services?: InputMaybe<Array<ServiceSubscription>>;
  states?: InputMaybe<Array<CustomerManagementUserState>>;
};

export type CustomerManagementUserDataPage = {
  __typename?: "CustomerManagementUserDataPage";
  paginationMetadata: PaginationMetadata;
  userData: Array<CustomerManagementUserData>;
};

export enum CustomerManagementUserState {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Invited = "INVITED",
  Unknown = "UNKNOWN",
}

export type DateFilterInput = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
};

export enum ElectricityPriceVariants {
  Flatrate = "FLATRATE",
  Proposed = "PROPOSED",
  ProposedOrFlatrate = "PROPOSED_OR_FLATRATE",
}

export enum ExistingRegistrationSalutationInput {
  Mr = "MR",
  Mrs = "MRS",
}

export enum FleetAtHomeAcceptProposedElectricityPriceMutationError {
  InternalError = "INTERNAL_ERROR",
  NoProposedElectricityPrice = "NO_PROPOSED_ELECTRICITY_PRICE",
  Unauthorized = "UNAUTHORIZED",
}

export type FleetAtHomeAcceptProposedElectricityPriceMutationResult = {
  __typename?: "FleetAtHomeAcceptProposedElectricityPriceMutationResult";
  errors: Array<FleetAtHomeAcceptProposedElectricityPriceMutationError>;
  success: Scalars["Boolean"]["output"];
};

export type FleetAtHomeActiveUsersKpi = {
  __typename?: "FleetAtHomeActiveUsersKpi";
  additionsLastPeriod: Scalars["Int"]["output"];
  count: Scalars["Int"]["output"];
};

export type FleetAtHomeChargesCountKpiValue = {
  __typename?: "FleetAtHomeChargesCountKpiValue";
  averagePreviousThreeMonths: Scalars["Decimal"]["output"];
  currentMonth: Scalars["Int"]["output"];
};

export type FleetAtHomeChargesEnergyKpiValue = {
  __typename?: "FleetAtHomeChargesEnergyKpiValue";
  averagePreviousThreeMonths: Scalars["Decimal"]["output"];
  currentMonth: Scalars["Decimal"]["output"];
};

export type FleetAtHomeChargesKpi = {
  __typename?: "FleetAtHomeChargesKpi";
  /** Average charge amount in kilowatt hours. */
  averageEnergyAmountKilowatthours: FleetAtHomeChargesEnergyKpiValue;
  count: FleetAtHomeChargesCountKpiValue;
  currentMonthProgress: FleetAtHomeKpiProgress;
};

export type FleetAtHomeCreditNote = {
  __typename?: "FleetAtHomeCreditNote";
  dateFrom: Scalars["Date"]["output"];
  dateTo: Scalars["Date"]["output"];
  energyAmountKilowatthours: Scalars["Decimal"]["output"];
  forecasted: Scalars["Boolean"]["output"];
  grossAmountInEuro?: Maybe<Scalars["Decimal"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  numberOfTransactions: Scalars["Int"]["output"];
  /** The url will not be set in a list request. It will only be set in a single request. */
  url?: Maybe<Scalars["String"]["output"]>;
};

export type FleetAtHomeCreditedAmountKpi = {
  __typename?: "FleetAtHomeCreditedAmountKpi";
  currentPeriodProgress: FleetAtHomeKpiProgress;
  grossAmountInEuro: FleetAtHomeCreditedAmountKpiValue;
};

export type FleetAtHomeCreditedAmountKpiValue = {
  __typename?: "FleetAtHomeCreditedAmountKpiValue";
  averagePreviousThreePeriods: Scalars["Decimal"]["output"];
  currentPeriod: Scalars["Decimal"]["output"];
};

export type FleetAtHomeCurrentElectricityPriceKpi = {
  __typename?: "FleetAtHomeCurrentElectricityPriceKpi";
  /** Average electricity price in ct per kilowatt hour. */
  average: Scalars["Decimal"]["output"];
  /** Maximum electricity price in ct per kilowatt hour. */
  maximum: Scalars["Decimal"]["output"];
  /** Minimum electricity price in ct per kilowatt hour. */
  minimum: Scalars["Decimal"]["output"];
};

export type FleetAtHomeCustomerSettings = {
  __typename?: "FleetAtHomeCustomerSettings";
  autoAcceptElectricityPrice?: Maybe<Scalars["Boolean"]["output"]>;
  companyIsPaying: Scalars["Boolean"]["output"];
  electricityPriceCertificateNeeded: Scalars["Boolean"]["output"];
  /** Electricity price in ct per kilowatt hour. */
  electricityPriceRangeFrom?: Maybe<Scalars["Decimal"]["output"]>;
  /** Electricity price in ct per kilowatt hour. */
  electricityPriceRangeTo?: Maybe<Scalars["Decimal"]["output"]>;
  electricityPriceVariants: ElectricityPriceVariants;
};

export type FleetAtHomeCustomerSettingsInput = {
  autoAcceptElectricityPrice?: InputMaybe<Scalars["Boolean"]["input"]>;
  companyIsPaying?: InputMaybe<Scalars["Boolean"]["input"]>;
  electricityPriceCertificateNeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Electricity price in ct per kilowatt hour. */
  electricityPriceRangeFrom?: InputMaybe<Scalars["Decimal"]["input"]>;
  /** Electricity price in ct per kilowatt hour. */
  electricityPriceRangeTo?: InputMaybe<Scalars["Decimal"]["input"]>;
  electricityPriceVariants?: InputMaybe<ElectricityPriceVariants>;
};

export enum FleetAtHomeDeclineProposedElectricityPriceMutationError {
  InternalError = "INTERNAL_ERROR",
  NoProposedElectricityPrice = "NO_PROPOSED_ELECTRICITY_PRICE",
  Unauthorized = "UNAUTHORIZED",
}

export type FleetAtHomeDeclineProposedElectricityPriceMutationResult = {
  __typename?: "FleetAtHomeDeclineProposedElectricityPriceMutationResult";
  errors: Array<FleetAtHomeDeclineProposedElectricityPriceMutationError>;
  success: Scalars["Boolean"]["output"];
};

export type FleetAtHomeElectricityPrice = {
  __typename?: "FleetAtHomeElectricityPrice";
  /** Basic fee in € per month. */
  basicFee?: Maybe<Scalars["Decimal"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  dateFrom: Scalars["Date"]["output"];
  dateTo?: Maybe<Scalars["Date"]["output"]>;
  /** Electricity price in ct per kilowatt hour. */
  electricityPricePerKilowattHour: Scalars["Decimal"]["output"];
  id: Scalars["String"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
  state: FleetAtHomeElectricityPriceState;
  url?: Maybe<Scalars["String"]["output"]>;
};

export enum FleetAtHomeElectricityPriceState {
  Accepted = "ACCEPTED",
  AutoAccepted = "AUTO_ACCEPTED",
  Declined = "DECLINED",
  Proposed = "PROPOSED",
  Withdrawn = "WITHDRAWN",
}

export type FleetAtHomeFlatrateElectricityPrice = {
  __typename?: "FleetAtHomeFlatrateElectricityPrice";
  conditionId: Scalars["String"]["output"];
  dateFrom: Scalars["Date"]["output"];
  dateTo: Scalars["Date"]["output"];
  /** Electricity price in ct per kilowatt hour. */
  electricityPricePerKilowattHour: Scalars["Decimal"]["output"];
};

export type FleetAtHomeKpiProgress = {
  __typename?: "FleetAtHomeKpiProgress";
  currentDay: Scalars["Int"]["output"];
  totalDays: Scalars["Int"]["output"];
};

export type FleetAtHomeManagementTransaction = {
  __typename?: "FleetAtHomeManagementTransaction";
  amount?: Maybe<Scalars["Decimal"]["output"]>;
  creditState: FleetAtHomeTransactionCreditState;
  energyAmountKilowatthours?: Maybe<Scalars["Decimal"]["output"]>;
  id: Scalars["ID"]["output"];
  startTime: Scalars["DateTime"]["output"];
  stopTime?: Maybe<Scalars["DateTime"]["output"]>;
  /** Salesforce ID of the user */
  userId: Scalars["ID"]["output"];
  userName?: Maybe<FleetAtHomeManagementUserName>;
};

export type FleetAtHomeManagementTransactionFilterInput = {
  isCredited?: InputMaybe<Scalars["Boolean"]["input"]>;
  startTime?: InputMaybe<StartTimeFilterInput>;
  userIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type FleetAtHomeManagementTransactionPage = {
  __typename?: "FleetAtHomeManagementTransactionPage";
  paginationMetadata: PaginationMetadata;
  transactions: Array<FleetAtHomeManagementTransaction>;
};

export type FleetAtHomeManagementUserName = {
  __typename?: "FleetAtHomeManagementUserName";
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  salutation?: Maybe<Salutation>;
};

export type FleetAtHomeManagementUserNameData = {
  __typename?: "FleetAtHomeManagementUserNameData";
  userId: Scalars["ID"]["output"];
  userName: FleetAtHomeManagementUserName;
};

export type FleetAtHomeOrder = {
  __typename?: "FleetAtHomeOrder";
  id: Scalars["ID"]["output"];
  invoiceUrl: Scalars["String"]["output"];
  netAmount: Scalars["Decimal"]["output"];
  state: Scalars["String"]["output"];
  totalAmount: Scalars["Decimal"]["output"];
  trackingNumber?: Maybe<Scalars["String"]["output"]>;
  vatAmount: Scalars["Decimal"]["output"];
};

export type FleetAtHomeOrderAddressInput = {
  addition?: InputMaybe<Scalars["String"]["input"]>;
  city: Scalars["String"]["input"];
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  country: Scalars["String"]["input"];
  department?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  houseNumber: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  postalCode: Scalars["String"]["input"];
  salutation: Salutation;
  street: Scalars["String"]["input"];
};

export type FleetAtHomeOrderInput = {
  billingAddress: FleetAtHomeOrderAddressInput;
  desiredDeliveryDate?: InputMaybe<Scalars["Date"]["input"]>;
  isCompanyPayment: Scalars["Boolean"]["input"];
  items: Array<FleetAtHomeOrderItemInput2>;
  shippingAddress: FleetAtHomeOrderAddressInput;
  totalAmount: Scalars["Decimal"]["input"];
};

export type FleetAtHomeOrderItemInput2 = {
  id: Scalars["ID"]["input"];
  quantity: Scalars["Decimal"]["input"];
};

export type FleetAtHomeOrderPreview = {
  __typename?: "FleetAtHomeOrderPreview";
  isCompanyPaymentAllowed: Scalars["Boolean"]["output"];
  items: Array<FleetAtHomeOrderPreviewItem>;
  netAmount: Scalars["Decimal"]["output"];
  shipping: Scalars["Decimal"]["output"];
  totalAmount: Scalars["Decimal"]["output"];
  vatAmount: Scalars["Decimal"]["output"];
};

export type FleetAtHomeOrderPreviewDataInput = {
  product: FleetAtHomeShopProductInput;
};

export type FleetAtHomeOrderPreviewItem = {
  __typename?: "FleetAtHomeOrderPreviewItem";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  price: Scalars["Decimal"]["output"];
  quantity: Scalars["Decimal"]["output"];
};

export enum FleetAtHomePlaceOrderMutationError {
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  PricesChanged = "PRICES_CHANGED",
  Unauthorized = "UNAUTHORIZED",
}

export type FleetAtHomePlaceOrderMutationResult = {
  __typename?: "FleetAtHomePlaceOrderMutationResult";
  errors: Array<FleetAtHomePlaceOrderMutationError>;
  success: Scalars["Boolean"]["output"];
};

export enum FleetAtHomeProposeElectricityPriceMutationError {
  ExistingProposedPrice = "EXISTING_PROPOSED_PRICE",
  InternalError = "INTERNAL_ERROR",
  Unauthorized = "UNAUTHORIZED",
}

export type FleetAtHomeProposeElectricityPriceMutationResult = {
  __typename?: "FleetAtHomeProposeElectricityPriceMutationResult";
  errors: Array<FleetAtHomeProposeElectricityPriceMutationError>;
  success: Scalars["Boolean"]["output"];
};

export type FleetAtHomeRegistrationDataInput = {
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  newsletterConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
  password: Scalars["String"]["input"];
  provisioningKey: Scalars["String"]["input"];
  salutation: RegistrationSalutationInput;
};

export type FleetAtHomeShopProduct = {
  __typename?: "FleetAtHomeShopProduct";
  accessories: Array<FleetAtHomeShopProductAccessory>;
  category: Scalars["String"]["output"];
  configurationOptions: Array<FleetAtHomeShopProductAccessory>;
  currency: Scalars["String"]["output"];
  detailedDescription: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image?: Maybe<FleetAtHomeShopProductImage>;
  listPrice: Scalars["Decimal"]["output"];
  name: Scalars["String"]["output"];
  obligatoryConfigurationOptions: Array<FleetAtHomeShopProductAccessory>;
  price: Scalars["Decimal"]["output"];
  shortDescription: Scalars["String"]["output"];
};

export type FleetAtHomeShopProductAccessory = {
  __typename?: "FleetAtHomeShopProductAccessory";
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  listPrice: Scalars["Decimal"]["output"];
  price: Scalars["Decimal"]["output"];
  shortDescription: Scalars["String"]["output"];
};

export type FleetAtHomeShopProductAccessoryInput = {
  id: Scalars["ID"]["input"];
};

export type FleetAtHomeShopProductImage = {
  __typename?: "FleetAtHomeShopProductImage";
  content: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
};

export type FleetAtHomeShopProductInput = {
  accessories: Array<FleetAtHomeShopProductAccessoryInput>;
  configurationOptions: Array<FleetAtHomeShopProductAccessoryInput>;
  id: Scalars["ID"]["input"];
  obligatoryConfigurationOptions: Array<FleetAtHomeShopProductAccessoryInput>;
};

export type FleetAtHomeStation = {
  __typename?: "FleetAtHomeStation";
  alias?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  currentElectricityPrice?: Maybe<FleetAtHomeElectricityPrice>;
  earliestPossibleElectricityPriceProposal: Scalars["Date"]["output"];
  houseNumber: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  order?: Maybe<FleetAtHomeOrder>;
  postalCode: Scalars["String"]["output"];
  proposedElectricityPrice?: Maybe<FleetAtHomeElectricityPrice>;
  provider: Scalars["String"]["output"];
  setupNecessary: Scalars["Boolean"]["output"];
  state: FleetAtHomeStationState;
  street: Scalars["String"]["output"];
};

export enum FleetAtHomeStationState {
  Active = "ACTIVE",
  Deactivated = "DEACTIVATED",
  OrderReceived = "ORDER_RECEIVED",
}

export type FleetAtHomeTransaction = {
  __typename?: "FleetAtHomeTransaction";
  amount?: Maybe<Scalars["Decimal"]["output"]>;
  creditState: FleetAtHomeTransactionCreditState;
  energyAmountKilowatthours?: Maybe<Scalars["Decimal"]["output"]>;
  id: Scalars["ID"]["output"];
  isPrivate: Scalars["Boolean"]["output"];
  startTime: Scalars["DateTime"]["output"];
  station: FleetAtHomeStation;
  stopTime?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum FleetAtHomeTransactionCreditState {
  Credited = "CREDITED",
  Open = "OPEN",
  PriceMissing = "PRICE_MISSING",
  PriceProposed = "PRICE_PROPOSED",
}

export type FleetAtHomeTransactionFilterInput = {
  amountFrom?: InputMaybe<Scalars["Decimal"]["input"]>;
  amountTo?: InputMaybe<Scalars["Decimal"]["input"]>;
  energyAmountKilowatthoursFrom?: InputMaybe<Scalars["Decimal"]["input"]>;
  energyAmountKilowatthoursTo?: InputMaybe<Scalars["Decimal"]["input"]>;
  isCredited?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPrivate?: InputMaybe<Scalars["Boolean"]["input"]>;
  startTime?: InputMaybe<DateFilterInput>;
};

export type FleetAtHomeTransactionPage = {
  __typename?: "FleetAtHomeTransactionPage";
  paginationMetadata: PaginationMetadata;
  totalAmount: Scalars["Decimal"]["output"];
  totalDurationMinutes: Scalars["Int"]["output"];
  totalEnergyAmountKilowatthours: Scalars["Decimal"]["output"];
  transactions: Array<FleetAtHomeTransaction>;
};

export enum FleetAtHomeUpdateStationMutationError {
  FlatratePriceActivationFailed = "FLATRATE_PRICE_ACTIVATION_FAILED",
  FlatratePriceAlreadyActive = "FLATRATE_PRICE_ALREADY_ACTIVE",
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
}

export type FleetAtHomeUpdateStationMutationResult = {
  __typename?: "FleetAtHomeUpdateStationMutationResult";
  errorDetails?: Maybe<OperationErrorDetails>;
  errors: Array<FleetAtHomeUpdateStationMutationError>;
  station?: Maybe<FleetAtHomeStation>;
  success: Scalars["Boolean"]["output"];
};

export type FleetAtHomeUserData = {
  __typename?: "FleetAtHomeUserData";
  addressDetails?: Maybe<AddressDetails>;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
  registrationLink?: Maybe<Scalars["String"]["output"]>;
  salutation?: Maybe<Salutation>;
  state: FleetAtHomeUserState;
  stations: Array<FleetAtHomeStation>;
};

export enum FleetAtHomeUserState {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Invited = "INVITED",
  Unknown = "UNKNOWN",
}

export type FleetAtHomeWallboxesKpi = {
  __typename?: "FleetAtHomeWallboxesKpi";
  additionsLastPeriod: Scalars["Int"]["output"];
  count: Scalars["Int"]["output"];
};

export enum GenerateInvitationLinkMutationError {
  InternalError = "INTERNAL_ERROR",
  Unauthorized = "UNAUTHORIZED",
}

export type GenerateInvitationLinkMutationResult = {
  __typename?: "GenerateInvitationLinkMutationResult";
  errors: Array<GenerateInvitationLinkMutationError>;
  invitationLink?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type InvitationDataInput = {
  customerId: Scalars["ID"]["input"];
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  salutation?: InputMaybe<RegistrationSalutationInput>;
};

export enum InvitationResult {
  UserExisted = "USER_EXISTED",
  UserInvited = "USER_INVITED",
}

export enum InviteUserMutationError {
  InternalError = "INTERNAL_ERROR",
  MultipleContactsFound = "MULTIPLE_CONTACTS_FOUND",
  Unauthorized = "UNAUTHORIZED",
  UserAlreadyRegistered = "USER_ALREADY_REGISTERED",
  UserDataDiffers = "USER_DATA_DIFFERS",
}

export type InviteUserMutationResult = {
  __typename?: "InviteUserMutationResult";
  caseNumber?: Maybe<Scalars["String"]["output"]>;
  errors: Array<InviteUserMutationError>;
  invitationResult?: Maybe<InvitationResult>;
  success: Scalars["Boolean"]["output"];
};

export type Maintenance = {
  __typename?: "Maintenance";
  dateFrom: Scalars["DateTime"]["output"];
  dateTo?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum MutationError {
  FlatratePriceActivationFailed = "FLATRATE_PRICE_ACTIVATION_FAILED",
  InternalError = "INTERNAL_ERROR",
  Unauthorized = "UNAUTHORIZED",
}

export type MutationResult = {
  __typename?: "MutationResult";
  errorDetails?: Maybe<OperationErrorDetails>;
  errors: Array<MutationError>;
  success: Scalars["Boolean"]["output"];
};

export type Notification = {
  __typename?: "Notification";
  dateFrom: Scalars["DateTime"]["output"];
  dateTo?: Maybe<Scalars["DateTime"]["output"]>;
  infoText?: Maybe<Scalars["String"]["output"]>;
  type: NotificationType;
};

export enum NotificationType {
  Announcement = "ANNOUNCEMENT",
  Maintenance = "MAINTENANCE",
}

export type OperationErrorDetails = {
  __typename?: "OperationErrorDetails";
  /** Upstream error code, distinct from the mutation error enum. */
  code?: Maybe<Scalars["String"]["output"]>;
  /** Upstream transaction or correlation identifier, when supplied. */
  correlationId?: Maybe<Scalars["String"]["output"]>;
  /** Language of the upstream message, when supplied. */
  language?: Maybe<Scalars["String"]["output"]>;
  /** Original human-readable business message from the upstream system. */
  message?: Maybe<Scalars["String"]["output"]>;
  /** UTC time this backend processes the upstream failure. */
  observedAt: Scalars["DateTime"]["output"];
  /** Upstream system supplying the error details. */
  source: Scalars["String"]["output"];
  /** Original upstream timestamp string; no timezone or normalized format is assumed. */
  upstreamTimestamp?: Maybe<Scalars["String"]["output"]>;
};

export type PaginationInput = {
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
};

export type PaginationMetadata = {
  __typename?: "PaginationMetadata";
  page: Scalars["Int"]["output"];
  pageSize: Scalars["Int"]["output"];
  totalEntries: Scalars["Int"]["output"];
  totalPages: Scalars["Int"]["output"];
};

export type Permissions = {
  __typename?: "Permissions";
  customers: Array<Customer>;
  fbsUser: Scalars["Boolean"]["output"];
  fbsUserCustomerIds: Array<Scalars["ID"]["output"]>;
  fleetAtHomeManager: Scalars["Boolean"]["output"];
  fleetAtHomeManagerCustomerIds: Array<Scalars["ID"]["output"]>;
  fleetAtHomeUser: Scalars["Boolean"]["output"];
  fleetAtHomeUserCustomerId?: Maybe<Scalars["ID"]["output"]>;
  gaasUser: Scalars["Boolean"]["output"];
  gaasUserCustomerIds: Array<Scalars["ID"]["output"]>;
  gasOci: Scalars["Boolean"]["output"];
  gasOciCustomerIds: Array<Scalars["ID"]["output"]>;
  gasRequester: Scalars["Boolean"]["output"];
  gasRequesterCustomerIds: Array<Scalars["ID"]["output"]>;
  gasStoreman: Scalars["Boolean"]["output"];
  gasStoremanCustomerIds: Array<Scalars["ID"]["output"]>;
  globalGasStoreman: Scalars["Boolean"]["output"];
  globalGasStoremanCustomerIds: Array<Scalars["ID"]["output"]>;
  preSalesManagerEquivolt: Scalars["Boolean"]["output"];
  preSalesManagerEquivoltCustomerIds: Array<Scalars["ID"]["output"]>;
  thgQuoteManager: Scalars["Boolean"]["output"];
  thgQuoteManagerCustomerIds: Array<Scalars["ID"]["output"]>;
  virtaUser: Scalars["Boolean"]["output"];
  virtaUserCustomerIds: Array<Scalars["ID"]["output"]>;
  wccManager: Scalars["Boolean"]["output"];
  wccManagerCustomerIds: Array<Scalars["ID"]["output"]>;
  westfalenIdAccountManager: Scalars["Boolean"]["output"];
  westfalenIdAccountManagerCustomerIds: Array<Scalars["ID"]["output"]>;
  wscManager: Scalars["Boolean"]["output"];
  wscManagerCustomerIds: Array<Scalars["ID"]["output"]>;
};

export type RegisterExistingCustomerInput = {
  captcha: Scalars["String"]["input"];
  customerId: Scalars["ID"]["input"];
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  salutation: ExistingRegistrationSalutationInput;
};

export enum RegisterExistingCustomerMutationError {
  CaptchaValidationFailed = "CAPTCHA_VALIDATION_FAILED",
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
  UserAlreadyExists = "USER_ALREADY_EXISTS",
}

export type RegisterExistingCustomerMutationResult = {
  __typename?: "RegisterExistingCustomerMutationResult";
  caseNumber?: Maybe<Scalars["String"]["output"]>;
  errors: Array<RegisterExistingCustomerMutationError>;
  success: Scalars["Boolean"]["output"];
};

export enum RegisterFleetAtHomeUserMutationError {
  InternalError = "INTERNAL_ERROR",
  InvitationLinkAlreadyUsed = "INVITATION_LINK_ALREADY_USED",
  NoValidProvisioningKey = "NO_VALID_PROVISIONING_KEY",
  Unauthorized = "UNAUTHORIZED",
}

export type RegisterFleetAtHomeUserMutationResult = {
  __typename?: "RegisterFleetAtHomeUserMutationResult";
  errors: Array<RegisterFleetAtHomeUserMutationError>;
  passwordSet?: Maybe<Scalars["Boolean"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export enum RegisterUserMutationError {
  CaptchaValidationFailed = "CAPTCHA_VALIDATION_FAILED",
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
  UserAlreadyExists = "USER_ALREADY_EXISTS",
}

export type RegisterUserMutationResult = {
  __typename?: "RegisterUserMutationResult";
  errors: Array<RegisterUserMutationError>;
  success: Scalars["Boolean"]["output"];
};

export type RegistrationData = {
  __typename?: "RegistrationData";
  email?: Maybe<Scalars["String"]["output"]>;
  finishedRegistration?: Maybe<Scalars["Boolean"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  salutation?: Maybe<Salutation>;
};

export enum RegistrationDataError {
  InternalError = "INTERNAL_ERROR",
  InvitationLinkAlreadyUsed = "INVITATION_LINK_ALREADY_USED",
  NoValidProvisioningKey = "NO_VALID_PROVISIONING_KEY",
}

export type RegistrationDataInput = {
  captcha: Scalars["String"]["input"];
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  newsletterConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
  salutation: RegistrationSalutationInput;
};

export type RegistrationDataResult = {
  __typename?: "RegistrationDataResult";
  errors: Array<RegistrationDataError>;
  registrationData?: Maybe<RegistrationData>;
  success: Scalars["Boolean"]["output"];
};

export enum RegistrationSalutationInput {
  Mr = "MR",
  Mrs = "MRS",
  NonBinary = "NON_BINARY",
}

export enum RegistrationType {
  Email = "EMAIL",
  Link = "LINK",
}

export type RootMutationType = {
  __typename?: "RootMutationType";
  clearCurrentUserCachedPermissions: MutationResult;
  customerManagementGenerateInvitationLink: GenerateInvitationLinkMutationResult;
  customerManagementInviteUser: InviteUserMutationResult;
  customerManagementRegisterInvitedUser: CustomerManagementRegisterUserMutationResult;
  customerManagementReviewRegistration: CustomerManagementReviewRegistrationResult;
  customerManagementUpdateInvitation: MutationResult;
  customerManagementUpdateUserPermissions: CustomerManagementUpdateUserPermissionsResult;
  deleteMyUser: MutationResult;
  finishRegistration: MutationResult;
  fleetAtHomeAcceptProposedElectricityPrice: FleetAtHomeAcceptProposedElectricityPriceMutationResult;
  fleetAtHomeDeclineProposedElectricityPrice: FleetAtHomeDeclineProposedElectricityPriceMutationResult;
  fleetAtHomeInviteUser: InviteUserMutationResult;
  fleetAtHomePlaceOrder: FleetAtHomePlaceOrderMutationResult;
  fleetAtHomeProposeElectricityPrice: FleetAtHomeProposeElectricityPriceMutationResult;
  fleetAtHomeUpdateCustomerSettings: MutationResult;
  fleetAtHomeUpdateStation: FleetAtHomeUpdateStationMutationResult;
  fleetAtHomeWithdrawProposedElectricityPrice: MutationResult;
  logoutCurrentUser: MutationResult;
  registerExistingCustomer: RegisterExistingCustomerMutationResult;
  registerFleetAtHomeUser: RegisterFleetAtHomeUserMutationResult;
  registerUser: RegisterUserMutationResult;
  thgQuoteDeletePendingVehicleRegistration: ThgQuoteDeletePendingVehicleRegistrationMutationResult;
  thgQuotePreregisterVehicle: ThgQuotePendingVehicleRegistrationMutationResult;
  thgQuoteRegisterVehicle: ThgQuoteVehicleRegistrationMutationResult;
  thgQuoteResubmitVehicleRegistrations: ThgQuoteResubmitVehicleRegistrationMutationResult;
  updateBankDetails: MutationResult;
  updateEmail: MutationResult;
  updatePassword: MutationResult;
  updateUserData: MutationResult;
  verifyEmail: VerifyEmailMutationResult;
  wccActivateCardSubscriptions: WccCardMutationResult;
  wccCancelCardCharges: WccCardMutationResult;
  wccChargeCards: WccCardMutationResult;
  wccDeactivateCardSubscriptions: WccCardMutationResult;
  wccDeactivateCards: WccCardMutationResult;
  wccPlaceCardOrder: WccPlaceCardOrderMutationResult;
  wccReactivateCards: WccCardMutationResult;
  wccUpdateCardLabels: WccCardMutationResult;
  wccUpdateCardSubscriptionAmounts: WccCardMutationResult;
  wccUpdateCardSubscriptionTerms: WccCardMutationResult;
  wscCreateIndividualCustomerPermission: WscMutationResult;
  wscDeactivateCard: WscMutationResult;
  wscDeleteIndividualCustomerPermission: WscMutationResult;
  wscPlaceCardOrder: WscCardMutationResult;
  wscPlaceReplacementCardOrder: WscMutationResult;
  wscRevokeFutureCardDeactivation: WscMutationResult;
  wscSendVirtualCardActivationLink: WscSendVirtualCardActivationLinkMutationResult;
  wscUpdateCard: WscCardMutationResult;
  wscUpdateIndividualCustomerPermission: WscMutationResult;
};

export type RootMutationTypeCustomerManagementGenerateInvitationLinkArgs = {
  customerId: Scalars["ID"]["input"];
  maximumRegistrations: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  needsReview: Scalars["Boolean"]["input"];
  serviceRoles: Array<ServiceRole>;
  validUntil: Scalars["DateTime"]["input"];
};

export type RootMutationTypeCustomerManagementInviteUserArgs = {
  invitationData: InvitationDataInput;
  serviceRoles: Array<ServiceRole>;
};

export type RootMutationTypeCustomerManagementRegisterInvitedUserArgs = {
  registrationData: CustomerManagementRegistrationDataInput;
};

export type RootMutationTypeCustomerManagementReviewRegistrationArgs = {
  customerId: Scalars["ID"]["input"];
  registrationId: Scalars["ID"]["input"];
  reviewOutcome: CustomerManagementRegistrationReviewOptions;
};

export type RootMutationTypeCustomerManagementUpdateInvitationArgs = {
  customerId: Scalars["ID"]["input"];
  invitationId: Scalars["ID"]["input"];
  updateData: UpdateInvitationInput;
};

export type RootMutationTypeCustomerManagementUpdateUserPermissionsArgs = {
  customerId: Scalars["ID"]["input"];
  serviceRoles: Array<ServiceRole>;
  userId: Scalars["ID"]["input"];
};

export type RootMutationTypeFinishRegistrationArgs = {
  address: AddressInput;
};

export type RootMutationTypeFleetAtHomeAcceptProposedElectricityPriceArgs = {
  stationId: Scalars["ID"]["input"];
};

export type RootMutationTypeFleetAtHomeDeclineProposedElectricityPriceArgs = {
  reason?: InputMaybe<Scalars["String"]["input"]>;
  stationId: Scalars["ID"]["input"];
};

export type RootMutationTypeFleetAtHomeInviteUserArgs = {
  invitationData: InvitationDataInput;
};

export type RootMutationTypeFleetAtHomePlaceOrderArgs = {
  data: FleetAtHomeOrderInput;
};

export type RootMutationTypeFleetAtHomeProposeElectricityPriceArgs = {
  basicFee: Scalars["Decimal"]["input"];
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  electricityPriceCertificateId?: InputMaybe<Scalars["ID"]["input"]>;
  electricityPricePerKilowattHour: Scalars["Decimal"]["input"];
  stationId: Scalars["ID"]["input"];
};

export type RootMutationTypeFleetAtHomeUpdateCustomerSettingsArgs = {
  customerId: Scalars["ID"]["input"];
  customerSettings: FleetAtHomeCustomerSettingsInput;
};

export type RootMutationTypeFleetAtHomeUpdateStationArgs = {
  alias?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  flatrateSettlementConditionId?: InputMaybe<Scalars["String"]["input"]>;
  flatrateSettlementIsActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  houseNumber?: InputMaybe<Scalars["String"]["input"]>;
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  stationId: Scalars["ID"]["input"];
  street?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootMutationTypeFleetAtHomeWithdrawProposedElectricityPriceArgs = {
  stationId: Scalars["ID"]["input"];
};

export type RootMutationTypeRegisterExistingCustomerArgs = {
  data: RegisterExistingCustomerInput;
};

export type RootMutationTypeRegisterFleetAtHomeUserArgs = {
  registrationData: FleetAtHomeRegistrationDataInput;
};

export type RootMutationTypeRegisterUserArgs = {
  registrationData: RegistrationDataInput;
};

export type RootMutationTypeThgQuoteDeletePendingVehicleRegistrationArgs = {
  id: Scalars["ID"]["input"];
};

export type RootMutationTypeThgQuotePreregisterVehicleArgs = {
  data: ThgQuotePendingVehicleRegistrationInput;
};

export type RootMutationTypeThgQuoteRegisterVehicleArgs = {
  data: ThgQuoteVehicleRegistrationInput;
};

export type RootMutationTypeThgQuoteResubmitVehicleRegistrationsArgs = {
  customerId: Scalars["ID"]["input"];
  ids: Array<Scalars["ID"]["input"]>;
};

export type RootMutationTypeUpdateBankDetailsArgs = {
  accountOwner: Scalars["String"]["input"];
  bic?: InputMaybe<Scalars["String"]["input"]>;
  iban: Scalars["String"]["input"];
};

export type RootMutationTypeUpdateEmailArgs = {
  email: Scalars["String"]["input"];
};

export type RootMutationTypeUpdatePasswordArgs = {
  password: Scalars["String"]["input"];
};

export type RootMutationTypeUpdateUserDataArgs = {
  userData: UserDataInput;
};

export type RootMutationTypeVerifyEmailArgs = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type RootMutationTypeWccActivateCardSubscriptionsArgs = {
  cardSubscriptions: Array<WccCardSubscriptionInput>;
  customerId: Scalars["ID"]["input"];
};

export type RootMutationTypeWccCancelCardChargesArgs = {
  cardNumbers: Array<Scalars["String"]["input"]>;
  customerId: Scalars["ID"]["input"];
};

export type RootMutationTypeWccChargeCardsArgs = {
  cardCharges: Array<WccCardChargeInput>;
  customerId: Scalars["ID"]["input"];
};

export type RootMutationTypeWccDeactivateCardSubscriptionsArgs = {
  cardNumbers: Array<Scalars["String"]["input"]>;
  customerId: Scalars["ID"]["input"];
};

export type RootMutationTypeWccDeactivateCardsArgs = {
  cardNumbers: Array<Scalars["String"]["input"]>;
  customerId: Scalars["ID"]["input"];
};

export type RootMutationTypeWccPlaceCardOrderArgs = {
  orderData: WccOrderDataInput;
};

export type RootMutationTypeWccReactivateCardsArgs = {
  cardNumbers: Array<Scalars["String"]["input"]>;
  customerId: Scalars["ID"]["input"];
};

export type RootMutationTypeWccUpdateCardLabelsArgs = {
  cardLabels: Array<WccCardLabelInput>;
  customerId: Scalars["ID"]["input"];
};

export type RootMutationTypeWccUpdateCardSubscriptionAmountsArgs = {
  cardSubscriptions: Array<WccCardSubscriptionInput>;
  customerId: Scalars["ID"]["input"];
};

export type RootMutationTypeWccUpdateCardSubscriptionTermsArgs = {
  cardSubscriptionTerms: Array<WccCardSubscriptionTermInput>;
  customerId: Scalars["ID"]["input"];
};

export type RootMutationTypeWscCreateIndividualCustomerPermissionArgs = {
  permissionData: WscIndividualCustomerPermissionCreateInput;
};

export type RootMutationTypeWscDeactivateCardArgs = {
  cardNr: Scalars["ID"]["input"];
  futureBlockDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type RootMutationTypeWscDeleteIndividualCustomerPermissionArgs = {
  customerId: Scalars["ID"]["input"];
  permissionId: Scalars["ID"]["input"];
};

export type RootMutationTypeWscPlaceCardOrderArgs = {
  orderData: WscOrderDataInput;
};

export type RootMutationTypeWscPlaceReplacementCardOrderArgs = {
  cardNr: Scalars["ID"]["input"];
  replacementCardOrderData: WscReplacementCardOrderDataInput;
};

export type RootMutationTypeWscRevokeFutureCardDeactivationArgs = {
  cardNr: Scalars["ID"]["input"];
};

export type RootMutationTypeWscSendVirtualCardActivationLinkArgs = {
  cardNr: Scalars["ID"]["input"];
};

export type RootMutationTypeWscUpdateCardArgs = {
  cardNr: Scalars["ID"]["input"];
  updateCardData: WscCardUpdateInput;
};

export type RootMutationTypeWscUpdateIndividualCustomerPermissionArgs = {
  customerId: Scalars["ID"]["input"];
  permissionId: Scalars["ID"]["input"];
  updatePermissionData: WscIndividualCustomerPermissionUpdateInput;
};

export type RootQueryType = {
  __typename?: "RootQueryType";
  activeMaintenance?: Maybe<Maintenance>;
  activeNotification?: Maybe<Notification>;
  currentUserFeatureFlags: Array<Scalars["FeatureFlag"]["output"]>;
  currentUserV2: CurrentUserQueryResult;
  customerManagementCustomer: CustomerManagementCustomer;
  customerManagementInvitations: CustomerManagementInvitationsPage;
  customerManagementSupportCasesForCustomer: SupportCasePage;
  customerManagementUserDataForCustomer: CustomerManagementUserDataPage;
  fleetAtHomeActiveUsersKpiForCustomer: FleetAtHomeActiveUsersKpi;
  fleetAtHomeChargesKpi: FleetAtHomeChargesKpi;
  fleetAtHomeChargesKpiForCustomer: FleetAtHomeChargesKpi;
  fleetAtHomeCreditNote: FleetAtHomeCreditNote;
  fleetAtHomeCreditNotes: Array<FleetAtHomeCreditNote>;
  fleetAtHomeCreditedAmountKpi: FleetAtHomeCreditedAmountKpi;
  fleetAtHomeCreditedAmountKpiForCustomer: FleetAtHomeCreditedAmountKpi;
  fleetAtHomeCurrentElectricityPriceKpiForCustomer?: Maybe<FleetAtHomeCurrentElectricityPriceKpi>;
  fleetAtHomeCustomerSettings: FleetAtHomeCustomerSettings;
  fleetAtHomeElectricityPriceHistoryForStation: Array<FleetAtHomeElectricityPrice>;
  fleetAtHomeFlatrateElectricityPrice?: Maybe<FleetAtHomeFlatrateElectricityPrice>;
  fleetAtHomeForecastedCreditNotes: Array<FleetAtHomeCreditNote>;
  fleetAtHomeOrderPreview: FleetAtHomeOrderPreview;
  fleetAtHomeShopProduct: FleetAtHomeShopProduct;
  fleetAtHomeShopProductCategories: Array<Scalars["String"]["output"]>;
  fleetAtHomeShopProducts: Array<FleetAtHomeShopProduct>;
  fleetAtHomeStation?: Maybe<FleetAtHomeStation>;
  fleetAtHomeStations: Array<FleetAtHomeStation>;
  fleetAtHomeTransaction?: Maybe<FleetAtHomeTransaction>;
  fleetAtHomeTransactions: FleetAtHomeTransactionPage;
  fleetAtHomeTransactionsForCustomer: FleetAtHomeManagementTransactionPage;
  fleetAtHomeUserDataForCustomer: Array<FleetAtHomeUserData>;
  fleetAtHomeUserNamesForCustomer: Array<FleetAtHomeManagementUserNameData>;
  fleetAtHomeWallboxesKpiForCustomer: FleetAtHomeWallboxesKpi;
  registrationData?: Maybe<RegistrationDataResult>;
  supportCaseCategorySelectOptions: Array<SelectOption>;
  supportCasesForUser: SupportCasePage;
  thgQuotePendingVehicleRegistration?: Maybe<ThgQuotePendingVehicleRegistration>;
  thgQuoteVehicleClasses: Array<ThgQuoteVehicleClassInfo>;
  thgQuoteVehicleRegistrationInfo: ThgQuoteVehicleRegistrationInfo;
  thgQuoteVehicleRegistrationsForCustomer: Array<ThgQuoteVehicleRegistration>;
  wccCardsForCustomer: WccCardPage;
  wccChargeHistoryForCard: WccChargePage;
  wccChargeHistoryForCustomer: WccChargesForCustomerPage;
  wccInvoice: WccInvoice;
  wccInvoicesForCustomer: WccInvoicePage;
  wccOrder: WccOrder;
  wccOrdersForCustomer: WccOrderPage;
  wscCard: WscCard;
  wscCardPermissionProducts: Array<WscPermissionProduct>;
  wscCardsForCustomer: WscCardPage;
  wscCustomer: WscCustomer;
  wscGoodsGroups: Array<Scalars["String"]["output"]>;
  wscIndividualCustomerPermissions: Array<WscIndividualCustomerPermission>;
  wscInvoice: WscInvoice;
  wscInvoicesForCustomer: WscInvoicePage;
  wscStations: Array<WscStation>;
  wscTransaction: WscTransaction;
  wscTransactionsForCustomer: WscTransactionPage;
};

export type RootQueryTypeCurrentUserFeatureFlagsArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeCustomerManagementCustomerArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeCustomerManagementInvitationsArgs = {
  customerId: Scalars["ID"]["input"];
  paginationParams: PaginationInput;
};

export type RootQueryTypeCustomerManagementSupportCasesForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
  filterParams?: InputMaybe<CustomerManagementSupportCaseFilterInput>;
  paginationParams: PaginationInput;
};

export type RootQueryTypeCustomerManagementUserDataForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
  filterParams?: InputMaybe<CustomerManagementUserDataFilterInput>;
  paginationParams: PaginationInput;
};

export type RootQueryTypeFleetAtHomeActiveUsersKpiForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeChargesKpiForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeCreditNoteArgs = {
  id: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeCreditedAmountKpiForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeCurrentElectricityPriceKpiForCustomerArgs =
  {
    customerId: Scalars["ID"]["input"];
  };

export type RootQueryTypeFleetAtHomeCustomerSettingsArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeElectricityPriceHistoryForStationArgs = {
  id: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeOrderPreviewArgs = {
  data: FleetAtHomeOrderPreviewDataInput;
};

export type RootQueryTypeFleetAtHomeShopProductArgs = {
  id: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeStationArgs = {
  id: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeTransactionArgs = {
  id: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeTransactionsArgs = {
  filterParams?: InputMaybe<FleetAtHomeTransactionFilterInput>;
  paginationParams: PaginationInput;
};

export type RootQueryTypeFleetAtHomeTransactionsForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
  filterParams?: InputMaybe<FleetAtHomeManagementTransactionFilterInput>;
  paginationParams: PaginationInput;
};

export type RootQueryTypeFleetAtHomeUserDataForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeUserNamesForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeFleetAtHomeWallboxesKpiForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeRegistrationDataArgs = {
  provisioningKey: Scalars["String"]["input"];
  registrationType?: InputMaybe<RegistrationType>;
};

export type RootQueryTypeSupportCasesForUserArgs = {
  filterParams?: InputMaybe<SupportCaseFilterInput>;
  paginationParams: PaginationInput;
};

export type RootQueryTypeThgQuotePendingVehicleRegistrationArgs = {
  id: Scalars["ID"]["input"];
};

export type RootQueryTypeThgQuoteVehicleRegistrationInfoArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeThgQuoteVehicleRegistrationsForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeWccCardsForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
  filterParams?: InputMaybe<WccCardFilterInput>;
  paginationParams: PaginationInput;
  sortParams?: InputMaybe<WccCardSortInput>;
};

export type RootQueryTypeWccChargeHistoryForCardArgs = {
  cardNr: Scalars["ID"]["input"];
  paginationParams: PaginationInput;
};

export type RootQueryTypeWccChargeHistoryForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
  filterParams?: InputMaybe<WccChargeHistoryForCustomerFilterInput>;
  paginationParams: PaginationInput;
};

export type RootQueryTypeWccInvoiceArgs = {
  invoiceId: Scalars["ID"]["input"];
};

export type RootQueryTypeWccInvoicesForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
  filterParams?: InputMaybe<WccInvoiceFilterInput>;
  paginationParams: PaginationInput;
};

export type RootQueryTypeWccOrderArgs = {
  orderId: Scalars["ID"]["input"];
};

export type RootQueryTypeWccOrdersForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
  filterParams?: InputMaybe<WccOrderFilterInput>;
  paginationParams: PaginationInput;
};

export type RootQueryTypeWscCardArgs = {
  cardNr: Scalars["ID"]["input"];
};

export type RootQueryTypeWscCardPermissionProductsArgs = {
  lang?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootQueryTypeWscCardsForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
  filterParams?: InputMaybe<WscCardFilterInput>;
  paginationParams: PaginationInput;
};

export type RootQueryTypeWscCustomerArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeWscGoodsGroupsArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeWscIndividualCustomerPermissionsArgs = {
  customerId: Scalars["ID"]["input"];
};

export type RootQueryTypeWscInvoiceArgs = {
  invoiceId: Scalars["ID"]["input"];
};

export type RootQueryTypeWscInvoicesForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
  filterParams?: InputMaybe<WscInvoiceFilterInput>;
  paginationParams: PaginationInput;
};

export type RootQueryTypeWscTransactionArgs = {
  transactionId: Scalars["ID"]["input"];
};

export type RootQueryTypeWscTransactionsForCustomerArgs = {
  customerId: Scalars["ID"]["input"];
  filterParams?: InputMaybe<WscTransactionFilterInput>;
  paginationParams: PaginationInput;
};

export enum Salutation {
  Company = "COMPANY",
  MarriedCouple = "MARRIED_COUPLE",
  Mr = "MR",
  Mrs = "MRS",
  MrsAndMr = "MRS_AND_MR",
  MrAndMrs = "MR_AND_MRS",
  NonBinary = "NON_BINARY",
  Unknown = "UNKNOWN",
}

export type SelectOption = {
  __typename?: "SelectOption";
  label: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export enum ServiceRole {
  FbsUser = "FBS_USER",
  FleetAtHomeManager = "FLEET_AT_HOME_MANAGER",
  FleetAtHomeUser = "FLEET_AT_HOME_USER",
  GaasBasicAdmin = "GAAS_BASIC_ADMIN",
  GaasBasicBasic = "GAAS_BASIC_BASIC",
  GaasBasicFree = "GAAS_BASIC_FREE",
  GaasBasicPremium = "GAAS_BASIC_PREMIUM",
  GasOci = "GAS_OCI",
  GasRequester = "GAS_REQUESTER",
  GasStoreman = "GAS_STOREMAN",
  GlobalGasStoreman = "GLOBAL_GAS_STOREMAN",
  PreSalesManagerEquivolt = "PRE_SALES_MANAGER_EQUIVOLT",
  ThgQuoteManager = "THG_QUOTE_MANAGER",
  VirtaUser = "VIRTA_USER",
  WccManager = "WCC_MANAGER",
  WestfalenIdAccountManager = "WESTFALEN_ID_ACCOUNT_MANAGER",
  WscManager = "WSC_MANAGER",
}

export enum ServiceSubscription {
  Equivolt = "EQUIVOLT",
  Fbs = "FBS",
  GaasBasic = "GAAS_BASIC",
  Gas = "GAS",
  GlobalGas = "GLOBAL_GAS",
  ThgQuote = "THG_QUOTE",
  Virta = "VIRTA",
  Wcc = "WCC",
  WestfalenId = "WESTFALEN_ID",
  Wsc = "WSC",
}

export type StartTimeFilterInput = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
};

export type SupportCase = {
  __typename?: "SupportCase";
  businessArea?: Maybe<Scalars["String"]["output"]>;
  caseNumber: Scalars["String"]["output"];
  category?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  customerName: Scalars["String"]["output"];
  customerNumber: Scalars["ID"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  state: SupportCaseState;
  subject: Scalars["String"]["output"];
  userFirstName?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["ID"]["output"];
  userLastName: Scalars["String"]["output"];
};

export type SupportCaseFilterInput = {
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
};

export type SupportCasePage = {
  __typename?: "SupportCasePage";
  paginationMetadata: PaginationMetadata;
  supportCases: Array<SupportCase>;
};

export enum SupportCaseState {
  Closed = "CLOSED",
  Escalated = "ESCALATED",
  InProgress = "IN_PROGRESS",
  New = "NEW",
  Unknown = "UNKNOWN",
  Waiting = "WAITING",
}

export enum ThgQuoteDeletePendingVehicleRegistrationMutationError {
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
}

export type ThgQuoteDeletePendingVehicleRegistrationMutationResult = {
  __typename?: "ThgQuoteDeletePendingVehicleRegistrationMutationResult";
  errors: Array<ThgQuoteDeletePendingVehicleRegistrationMutationError>;
  success: Scalars["Boolean"]["output"];
};

export type ThgQuotePendingVehicleRegistration = {
  __typename?: "ThgQuotePendingVehicleRegistration";
  externalId: Scalars["ID"]["output"];
  fin?: Maybe<Scalars["String"]["output"]>;
  vehicleAlias?: Maybe<Scalars["String"]["output"]>;
  vehicleCertificateFrontImageId: Scalars["ID"]["output"];
  vehicleClass: Scalars["String"]["output"];
};

export type ThgQuotePendingVehicleRegistrationInput = {
  fin?: InputMaybe<Scalars["String"]["input"]>;
  vehicleAlias?: InputMaybe<Scalars["String"]["input"]>;
  vehicleCertificateFrontImageId: Scalars["ID"]["input"];
  vehicleClass: Scalars["String"]["input"];
};

export enum ThgQuotePendingVehicleRegistrationMutationError {
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
}

export type ThgQuotePendingVehicleRegistrationMutationResult = {
  __typename?: "ThgQuotePendingVehicleRegistrationMutationResult";
  errors: Array<ThgQuotePendingVehicleRegistrationMutationError>;
  pendingVehicleRegistrationId?: Maybe<Scalars["ID"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type ThgQuoteResubmitVehicleRegistrationMutationResult = {
  __typename?: "ThgQuoteResubmitVehicleRegistrationMutationResult";
  errors: Array<MutationError>;
  results: Array<ThgQuoteResubmitVehicleRegistrationResult>;
  success: Scalars["Boolean"]["output"];
};

export type ThgQuoteResubmitVehicleRegistrationResult = {
  __typename?: "ThgQuoteResubmitVehicleRegistrationResult";
  error?: Maybe<MutationError>;
  id: Scalars["ID"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type ThgQuoteVehicleClassInfo = {
  __typename?: "ThgQuoteVehicleClassInfo";
  currency?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["String"]["output"];
  price?: Maybe<Scalars["Decimal"]["output"]>;
  vehicleClass: Scalars["ID"]["output"];
};

export type ThgQuoteVehicleRegistration = {
  __typename?: "ThgQuoteVehicleRegistration";
  creationDate: Scalars["Date"]["output"];
  fin?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  state: ThgQuoteVehicleRegistrationState;
  validForResubmission: Scalars["Boolean"]["output"];
  vehicleAlias: Scalars["String"]["output"];
  vehicleClass: Scalars["String"]["output"];
  vehicleOwner?: Maybe<Scalars["String"]["output"]>;
  year: Scalars["String"]["output"];
};

export type ThgQuoteVehicleRegistrationInfo = {
  __typename?: "ThgQuoteVehicleRegistrationInfo";
  addressDetailsNecessary: Scalars["Boolean"]["output"];
  vatIdentificationNumberNecessary: Scalars["Boolean"]["output"];
};

export type ThgQuoteVehicleRegistrationInput = {
  address?: InputMaybe<AddressInput>;
  customerId: Scalars["ID"]["input"];
  fin: Scalars["String"]["input"];
  vatIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  vehicleAlias: Scalars["String"]["input"];
  vehicleCertificateFrontImageId: Scalars["ID"]["input"];
  vehicleClass: Scalars["String"]["input"];
  year: Scalars["String"]["input"];
};

export enum ThgQuoteVehicleRegistrationMutationError {
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
}

export type ThgQuoteVehicleRegistrationMutationResult = {
  __typename?: "ThgQuoteVehicleRegistrationMutationResult";
  errors: Array<ThgQuoteVehicleRegistrationMutationError>;
  success: Scalars["Boolean"]["output"];
};

export enum ThgQuoteVehicleRegistrationState {
  Approved = "APPROVED",
  InReview = "IN_REVIEW",
  Paid = "PAID",
  PaymentPending = "PAYMENT_PENDING",
  Rejected = "REJECTED",
  Submitted = "SUBMITTED",
}

export type UpdateInvitationInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  maximumRegistrations?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  serviceRoles?: InputMaybe<Array<ServiceRole>>;
  validUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type User = {
  __typename?: "User";
  activationState?: Maybe<Scalars["String"]["output"]>;
  addressDetails?: Maybe<AddressDetails>;
  bankDetails?: Maybe<BankDetails>;
  capabilities: UserCapabilities;
  email: Scalars["String"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName: Scalars["String"]["output"];
  locale?: Maybe<Scalars["String"]["output"]>;
  permissions: Permissions;
  personalSapId?: Maybe<Scalars["String"]["output"]>;
  salutation: Salutation;
  /** Salesforce ID of the user */
  userId: Scalars["ID"]["output"];
};

export type UserCapabilities = {
  __typename?: "UserCapabilities";
  canStoreAddressDetails: Scalars["Boolean"]["output"];
  canStoreBankDetails: Scalars["Boolean"]["output"];
};

export type UserDataInput = {
  address?: InputMaybe<AddressInput>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  salutation: Salutation;
};

export enum VerifyEmailMutationError {
  InternalError = "INTERNAL_ERROR",
  TooManyRequests = "TOO_MANY_REQUESTS",
  Unauthorized = "UNAUTHORIZED",
}

export type VerifyEmailMutationResult = {
  __typename?: "VerifyEmailMutationResult";
  errors: Array<VerifyEmailMutationError>;
  passwordSet?: Maybe<Scalars["Boolean"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type WccCard = {
  __typename?: "WccCard";
  archivedAt?: Maybe<Scalars["Date"]["output"]>;
  cardNr: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
  lastChargedAt?: Maybe<Scalars["Date"]["output"]>;
  orderId?: Maybe<Scalars["String"]["output"]>;
  reloadCount?: Maybe<Scalars["Int"]["output"]>;
  state: WccCardState;
  subscriptionActiveFrom?: Maybe<Scalars["Date"]["output"]>;
  subscriptionActiveUntil?: Maybe<Scalars["Date"]["output"]>;
  subscriptionAmount: Scalars["Decimal"]["output"];
  subscriptionState: WccSubscriptionState;
  totalAmountPerPeriod: Scalars["Decimal"]["output"];
};

export type WccCardChargeInput = {
  cardNr: Scalars["ID"]["input"];
  chargeAmount: Scalars["Decimal"]["input"];
};

export type WccCardFilterInput = {
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<WccCardState>;
  subscriptionStates?: InputMaybe<Array<WccSubscriptionState>>;
};

export type WccCardLabelInput = {
  cardNr: Scalars["ID"]["input"];
  label: Scalars["String"]["input"];
};

export enum WccCardMutationError {
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
}

export type WccCardMutationResult = {
  __typename?: "WccCardMutationResult";
  cardResults: Array<WccCardUpdateResult>;
  errors: Array<WccCardMutationError>;
  success: Scalars["Boolean"]["output"];
};

export type WccCardPage = {
  __typename?: "WccCardPage";
  cards: Array<WccCard>;
  paginationMetadata: PaginationMetadata;
};

export enum WccCardSortDirection {
  Asc = "ASC",
  Desc = "DESC",
}

export enum WccCardSortField {
  CardNr = "CARD_NR",
  Label = "LABEL",
  LastChargedAt = "LAST_CHARGED_AT",
  OrderId = "ORDER_ID",
  ReloadCount = "RELOAD_COUNT",
  SubscriptionActiveFrom = "SUBSCRIPTION_ACTIVE_FROM",
  SubscriptionActiveUntil = "SUBSCRIPTION_ACTIVE_UNTIL",
  SubscriptionAmount = "SUBSCRIPTION_AMOUNT",
  SubscriptionState = "SUBSCRIPTION_STATE",
  TotalAmountPerPeriod = "TOTAL_AMOUNT_PER_PERIOD",
}

export type WccCardSortInput = {
  direction: WccCardSortDirection;
  field: WccCardSortField;
};

export enum WccCardState {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
}

export type WccCardSubscriptionInput = {
  cardNr: Scalars["ID"]["input"];
  subscriptionAmount?: InputMaybe<Scalars["Decimal"]["input"]>;
};

export type WccCardSubscriptionTermInput = {
  cardNr: Scalars["ID"]["input"];
  subscriptionActiveFrom?: InputMaybe<Scalars["Date"]["input"]>;
  subscriptionActiveUntil?: InputMaybe<Scalars["Date"]["input"]>;
};

export type WccCardUpdateResult = {
  __typename?: "WccCardUpdateResult";
  cardNr: Scalars["ID"]["output"];
  error?: Maybe<WccCardUpdateResultError>;
  success: Scalars["Boolean"]["output"];
};

export enum WccCardUpdateResultError {
  CardAlreadyChargedToday = "CARD_ALREADY_CHARGED_TODAY",
  InternalError = "INTERNAL_ERROR",
}

export type WccCharge = {
  __typename?: "WccCharge";
  amount: Scalars["Decimal"]["output"];
  cardNr: Scalars["ID"]["output"];
  chargedAt: Scalars["Date"]["output"];
  isCancelable: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  type: WccChargeType;
};

export type WccChargeHistoryForCustomerFilterInput = {
  amountFrom?: InputMaybe<Scalars["Decimal"]["input"]>;
  amountTo?: InputMaybe<Scalars["Decimal"]["input"]>;
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  types?: InputMaybe<Array<WccChargeType>>;
};

export type WccChargePage = {
  __typename?: "WccChargePage";
  charges: Array<WccCharge>;
  paginationMetadata: PaginationMetadata;
};

export enum WccChargeType {
  Credit = "CREDIT",
  OneTime = "ONE_TIME",
  Subscription = "SUBSCRIPTION",
}

export type WccChargesForCustomerPage = {
  __typename?: "WccChargesForCustomerPage";
  charges: Array<WccCharge>;
  downloadLink: Scalars["String"]["output"];
  paginationMetadata: PaginationMetadata;
};

export type WccInvoice = {
  __typename?: "WccInvoice";
  documentAvailable: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  invoicedAt: Scalars["Date"]["output"];
  netValue: Scalars["Decimal"]["output"];
  /** The url will not be set in a list request. It will only be set in a single request. */
  url?: Maybe<Scalars["String"]["output"]>;
};

export type WccInvoiceFilterInput = {
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
};

export type WccInvoicePage = {
  __typename?: "WccInvoicePage";
  invoices: Array<WccInvoice>;
  paginationMetadata: PaginationMetadata;
};

export type WccOrder = {
  __typename?: "WccOrder";
  batch1?: Maybe<WccOrderBatch>;
  batch2?: Maybe<WccOrderBatch>;
  batch3?: Maybe<WccOrderBatch>;
  /** The cards will not be set in a list request. It will only be set in a single request. */
  cards?: Maybe<Array<WccCard>>;
  createdAt: Scalars["DateTime"]["output"];
  orderNumber: Scalars["ID"]["output"];
  state: WccOrderState;
};

export type WccOrderBatch = {
  __typename?: "WccOrderBatch";
  cardQuantity: Scalars["Int"]["output"];
  subscriptionAmount: Scalars["Decimal"]["output"];
};

export type WccOrderBatchInput = {
  cardQuantity: Scalars["Int"]["input"];
  subscriptionAmount: Scalars["Decimal"]["input"];
};

export type WccOrderDataInput = {
  batch1: WccOrderBatchInput;
  batch2?: InputMaybe<WccOrderBatchInput>;
  batch3?: InputMaybe<WccOrderBatchInput>;
  customerId: Scalars["ID"]["input"];
};

export type WccOrderFilterInput = {
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  states?: InputMaybe<Array<WccOrderState>>;
};

export type WccOrderPage = {
  __typename?: "WccOrderPage";
  orders: Array<WccOrder>;
  paginationMetadata: PaginationMetadata;
};

export enum WccOrderState {
  Completed = "COMPLETED",
  InProgress = "IN_PROGRESS",
  New = "NEW",
  Received = "RECEIVED",
  Unknown = "UNKNOWN",
}

export enum WccPlaceCardOrderMutationError {
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
}

export type WccPlaceCardOrderMutationResult = {
  __typename?: "WccPlaceCardOrderMutationResult";
  errors: Array<WccPlaceCardOrderMutationError>;
  success: Scalars["Boolean"]["output"];
};

export enum WccSubscriptionState {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export type WscAddressInput = {
  addition?: InputMaybe<Scalars["String"]["input"]>;
  city: Scalars["String"]["input"];
  country: Scalars["String"]["input"];
  houseNumber: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  postalCode: Scalars["String"]["input"];
  street: Scalars["String"]["input"];
};

export type WscCard = {
  __typename?: "WscCard";
  acceptanceType: WscCardAcceptanceType;
  additionalText?: Maybe<Scalars["String"]["output"]>;
  alternativeShippingAddress?: Maybe<WscCardAddress>;
  bookingText?: Maybe<Scalars["String"]["output"]>;
  cardNr: Scalars["ID"]["output"];
  costCenter?: Maybe<Scalars["String"]["output"]>;
  /** The customer to which this wscCard belongs to. Attention: only request this field if you really need it. It causes additional lookups. */
  customer?: Maybe<WscCustomer>;
  /** The card pin is encrypted and has to be decrypted. It should only be requested for single cards. */
  decryptedCardPin?: Maybe<Scalars["String"]["output"]>;
  electricityCardEnabled: Scalars["Boolean"]["output"];
  electricityCardInformation?: Maybe<WscCardElectricityCardInformation>;
  expiresAt: Scalars["String"]["output"];
  futureBlockDate?: Maybe<Scalars["Date"]["output"]>;
  gasStation?: Maybe<Scalars["String"]["output"]>;
  gasStationId?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  licensePlate?: Maybe<Scalars["String"]["output"]>;
  maxTransactionsPerDay: Scalars["Int"]["output"];
  permissionLevel: WscCardPermissionLevel;
  permissionProductIds: Array<Scalars["String"]["output"]>;
  requestInfoEntry: Scalars["Boolean"]["output"];
  requestKilometresEntry: Scalars["Boolean"]["output"];
  state: WscCardState;
  virtualCardEnabled: Scalars["Boolean"]["output"];
  virtualCardInformation?: Maybe<WscCardVirtualCardInformation>;
};

export enum WscCardAcceptanceType {
  AssociationCard = "ASSOCIATION_CARD",
  NetworkCard = "NETWORK_CARD",
  StationCard = "STATION_CARD",
}

export type WscCardAddress = {
  __typename?: "WscCardAddress";
  addition?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  postalCode: Scalars["String"]["output"];
  street: Scalars["String"]["output"];
};

export type WscCardElectricityCardInformation = {
  __typename?: "WscCardElectricityCardInformation";
  /** The email address recorded directly on the electricity card */
  email?: Maybe<Scalars["String"]["output"]>;
};

export type WscCardFilterInput = {
  individualPermissionIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  states?: InputMaybe<Array<WscCardState>>;
};

export enum WscCardMutationError {
  EmailAlreadyAssigned = "EMAIL_ALREADY_ASSIGNED",
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
}

export type WscCardMutationResult = {
  __typename?: "WscCardMutationResult";
  errors: Array<WscCardMutationError>;
  success: Scalars["Boolean"]["output"];
};

export type WscCardPage = {
  __typename?: "WscCardPage";
  cards: Array<WscCard>;
  downloadLink: Scalars["String"]["output"];
  paginationMetadata: PaginationMetadata;
};

export enum WscCardPermissionLevel {
  DieselService = "DIESEL_SERVICE",
  ElectricityService = "ELECTRICITY_SERVICE",
  FuelService = "FUEL_SERVICE",
  FullService = "FULL_SERVICE",
  Individual = "INDIVIDUAL",
  Unknown = "UNKNOWN",
}

export enum WscCardState {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Ordered = "ORDERED",
  Recorded = "RECORDED",
}

/** Partial update, all fields are optional. Only provide the fields you want to update. */
export type WscCardUpdateInput = {
  acceptanceType?: InputMaybe<WscCardAcceptanceType>;
  additionalText?: InputMaybe<Scalars["String"]["input"]>;
  bookingText?: InputMaybe<Scalars["String"]["input"]>;
  costCenter?: InputMaybe<Scalars["String"]["input"]>;
  electricityCardEmail?: InputMaybe<Scalars["String"]["input"]>;
  electricityCardEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  gasStationId?: InputMaybe<Scalars["ID"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  licensePlate?: InputMaybe<Scalars["String"]["input"]>;
  maxTransactionsPerDay?: InputMaybe<Scalars["Int"]["input"]>;
  permissionLevel?: InputMaybe<WscCardPermissionLevel>;
  permissionProductIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  pin?: InputMaybe<Scalars["String"]["input"]>;
  virtualCardEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  virtualCardInformation?: InputMaybe<WscVirtualCardInput>;
};

export enum WscCardVirtualAppIdentification {
  Easymove = "EASYMOVE",
  Fillibri = "FILLIBRI",
}

export type WscCardVirtualCardInformation = {
  __typename?: "WscCardVirtualCardInformation";
  appIdentification: WscCardVirtualAppIdentification;
  contactType: WscCardVirtualContactType;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  salutation?: Maybe<Salutation>;
};

export enum WscCardVirtualContactType {
  Email = "EMAIL",
  PhoneNumber = "PHONE_NUMBER",
}

export type WscCustomer = {
  __typename?: "WscCustomer";
  id: Scalars["ID"]["output"];
  openSalesVolumeInCurrentBillingPeriod: Scalars["Decimal"]["output"];
  salesLimitPerBillingPeriod: Scalars["Decimal"]["output"];
  shippingAddress: WscCardAddress;
  usedSalesVolumeInCurrentBillingPeriod: Scalars["Decimal"]["output"];
};

export type WscIndividualCustomerPermission = {
  __typename?: "WscIndividualCustomerPermission";
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  permissionProductIds: Array<Scalars["String"]["output"]>;
  usageCount: Scalars["Int"]["output"];
};

export type WscIndividualCustomerPermissionCreateInput = {
  customerId: Scalars["ID"]["input"];
  label: Scalars["String"]["input"];
  permissionProductIds: Array<Scalars["String"]["input"]>;
};

export type WscIndividualCustomerPermissionUpdateInput = {
  label: Scalars["String"]["input"];
};

export type WscInvoice = {
  __typename?: "WscInvoice";
  documentAvailable: Scalars["Boolean"]["output"];
  grossValue: Scalars["Decimal"]["output"];
  id: Scalars["ID"]["output"];
  invoicedAt: Scalars["Date"]["output"];
  /** The url will not be set in a list request. It will only be set in a single request. */
  url?: Maybe<Scalars["String"]["output"]>;
};

export type WscInvoiceFilterInput = {
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
};

export type WscInvoicePage = {
  __typename?: "WscInvoicePage";
  invoices: Array<WscInvoice>;
  paginationMetadata: PaginationMetadata;
};

export enum WscMutationError {
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
}

export type WscMutationResult = {
  __typename?: "WscMutationResult";
  errors: Array<WscMutationError>;
  success: Scalars["Boolean"]["output"];
};

export type WscOrderDataInput = {
  acceptanceType: WscCardAcceptanceType;
  additionalText?: InputMaybe<Scalars["String"]["input"]>;
  alternativeShippingAddress?: InputMaybe<WscAddressInput>;
  bookingText?: InputMaybe<Scalars["String"]["input"]>;
  costCenter?: InputMaybe<Scalars["String"]["input"]>;
  customerId: Scalars["ID"]["input"];
  electricityCardEmail?: InputMaybe<Scalars["String"]["input"]>;
  electricityCardEnabled: Scalars["Boolean"]["input"];
  gasStationId?: InputMaybe<Scalars["ID"]["input"]>;
  label: Scalars["String"]["input"];
  licensePlate?: InputMaybe<Scalars["String"]["input"]>;
  maxTransactionsPerDay: Scalars["Int"]["input"];
  permissionLevel: WscCardPermissionLevel;
  permissionProductIds: Array<Scalars["String"]["input"]>;
  pin: Scalars["String"]["input"];
  requestInfoEntry: Scalars["Boolean"]["input"];
  requestKilometresEntry: Scalars["Boolean"]["input"];
  virtualCardInformation?: InputMaybe<WscVirtualCardInput>;
};

export type WscPermissionProduct = {
  __typename?: "WscPermissionProduct";
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type WscReplacementCardOrderDataInput = {
  alternativeShippingAddress?: InputMaybe<WscAddressInput>;
  replacementType: WscReplacementType;
};

export enum WscReplacementType {
  NewCardNr = "NEW_CARD_NR",
  SameCardNr = "SAME_CARD_NR",
}

export enum WscSendVirtualCardActivationLinkMutationError {
  AlreadySent = "ALREADY_SENT",
  InternalError = "INTERNAL_ERROR",
  InvalidParams = "INVALID_PARAMS",
  Unauthorized = "UNAUTHORIZED",
}

export type WscSendVirtualCardActivationLinkMutationResult = {
  __typename?: "WscSendVirtualCardActivationLinkMutationResult";
  errors: Array<WscSendVirtualCardActivationLinkMutationError>;
  success: Scalars["Boolean"]["output"];
};

export type WscStation = {
  __typename?: "WscStation";
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

export type WscTransaction = {
  __typename?: "WscTransaction";
  card?: Maybe<WscCard>;
  city: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  gasStation: Scalars["String"]["output"];
  goodsGroup: Scalars["String"]["output"];
  grossValue: Scalars["Decimal"]["output"];
  id: Scalars["String"]["output"];
  info?: Maybe<Scalars["String"]["output"]>;
  mileage?: Maybe<Scalars["Int"]["output"]>;
  postalCode: Scalars["String"]["output"];
  quantity: Scalars["Decimal"]["output"];
  receiptNr: Scalars["String"]["output"];
  street: Scalars["String"]["output"];
  transactionCardData: WscTransactionCardData;
  unit: Scalars["String"]["output"];
};

export type WscTransactionCardData = {
  __typename?: "WscTransactionCardData";
  additionalText?: Maybe<Scalars["String"]["output"]>;
  bookingText?: Maybe<Scalars["String"]["output"]>;
  cardNr: Scalars["ID"]["output"];
  costCenter?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  licensePlate?: Maybe<Scalars["String"]["output"]>;
};

export type WscTransactionFilterInput = {
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  goodsGroups?: InputMaybe<Array<Scalars["String"]["input"]>>;
  grossValueFrom?: InputMaybe<Scalars["Decimal"]["input"]>;
  grossValueTo?: InputMaybe<Scalars["Decimal"]["input"]>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
};

export type WscTransactionPage = {
  __typename?: "WscTransactionPage";
  downloadLink: Scalars["String"]["output"];
  paginationMetadata: PaginationMetadata;
  transactions: Array<WscTransaction>;
};

export type WscVirtualCardInput = {
  contactType: WscCardVirtualContactType;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName: Scalars["String"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  salutation: Salutation;
};

export type UpdateBankDetailsMutationVariables = Exact<{
  accountOwner: Scalars["String"]["input"];
  iban: Scalars["String"]["input"];
  bic?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateBankDetailsMutation = {
  __typename?: "RootMutationType";
  updateBankDetails: {
    __typename?: "MutationResult";
    success: boolean;
    errors: Array<MutationError>;
  };
};

export type UpdateEmailMutationVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type UpdateEmailMutation = {
  __typename?: "RootMutationType";
  updateEmail: {
    __typename?: "MutationResult";
    success: boolean;
    errors: Array<MutationError>;
  };
};

export type UpdatePasswordMutationVariables = Exact<{
  password: Scalars["String"]["input"];
}>;

export type UpdatePasswordMutation = {
  __typename?: "RootMutationType";
  updatePassword: {
    __typename?: "MutationResult";
    success: boolean;
    errors: Array<MutationError>;
  };
};

export type UpdateUserDataMutationVariables = Exact<{
  userData: UserDataInput;
}>;

export type UpdateUserDataMutation = {
  __typename?: "RootMutationType";
  updateUserData: {
    __typename?: "MutationResult";
    success: boolean;
    errors: Array<MutationError>;
  };
};

export type DeleteMyUserMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteMyUserMutation = {
  __typename?: "RootMutationType";
  deleteMyUser: {
    __typename?: "MutationResult";
    success: boolean;
    errors: Array<MutationError>;
  };
};

export type GetSupportCasesForUserQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
}>;

export type GetSupportCasesForUserQuery = {
  __typename?: "RootQueryType";
  supportCasesForUser: {
    __typename?: "SupportCasePage";
    supportCases: Array<{
      __typename?: "SupportCase";
      id: string;
      caseNumber: string;
      userId: string;
      userFirstName?: string | null;
      userLastName: string;
      customerNumber: string;
      customerName: string;
      createdAt: any;
      subject: string;
      description?: string | null;
      category?: string | null;
      businessArea?: string | null;
      state: SupportCaseState;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type GetFleetAtHomeTransactionsForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  isCredited?: InputMaybe<Scalars["Boolean"]["input"]>;
  startTime?: InputMaybe<StartTimeFilterInput>;
  userIds?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
}>;

export type GetFleetAtHomeTransactionsForCustomerQuery = {
  __typename?: "RootQueryType";
  transactionsPage: {
    __typename?: "FleetAtHomeManagementTransactionPage";
    transactions: Array<{
      __typename?: "FleetAtHomeManagementTransaction";
      id: string;
      amount?: string | null;
      creditState: FleetAtHomeTransactionCreditState;
      energyAmountKilowatthours?: string | null;
      startTime: any;
      stopTime?: any | null;
      userId: string;
      userName?: {
        __typename?: "FleetAtHomeManagementUserName";
        salutation?: Salutation | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type GetFleetAtHomeUserNamesForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetFleetAtHomeUserNamesForCustomerQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeUserNamesForCustomer: Array<{
    __typename?: "FleetAtHomeManagementUserNameData";
    userId: string;
    userName: {
      __typename?: "FleetAtHomeManagementUserName";
      salutation?: Salutation | null;
      firstName?: string | null;
      lastName?: string | null;
    };
  }>;
};

export type GetFleetAtHomeActiveUsersKpiForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetFleetAtHomeActiveUsersKpiForCustomerQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeActiveUsersKpiForCustomer: {
    __typename?: "FleetAtHomeActiveUsersKpi";
    count: number;
    additionsLastPeriod: number;
  };
};

export type GetFleetAtHomeChargesKpiForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetFleetAtHomeChargesKpiForCustomerQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeChargesKpiForCustomer: {
    __typename?: "FleetAtHomeChargesKpi";
    count: {
      __typename?: "FleetAtHomeChargesCountKpiValue";
      averagePreviousThreeMonths: string;
      currentMonth: number;
    };
    averageEnergyAmountKilowatthours: {
      __typename?: "FleetAtHomeChargesEnergyKpiValue";
      averagePreviousThreeMonths: string;
      currentMonth: string;
    };
    currentMonthProgress: {
      __typename?: "FleetAtHomeKpiProgress";
      currentDay: number;
      totalDays: number;
    };
  };
};

export type GetFleetAtHomeCreditedAmountKpiForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetFleetAtHomeCreditedAmountKpiForCustomerQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeCreditedAmountKpiForCustomer: {
    __typename?: "FleetAtHomeCreditedAmountKpi";
    grossAmountInEuro: {
      __typename?: "FleetAtHomeCreditedAmountKpiValue";
      averagePreviousThreePeriods: string;
      currentPeriod: string;
    };
    currentPeriodProgress: {
      __typename?: "FleetAtHomeKpiProgress";
      currentDay: number;
      totalDays: number;
    };
  };
};

export type GetFleetAtHomeCurrentElectricityPriceKpiForCustomerQueryVariables =
  Exact<{
    customerId: Scalars["ID"]["input"];
  }>;

export type GetFleetAtHomeCurrentElectricityPriceKpiForCustomerQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeCurrentElectricityPriceKpiForCustomer?: {
    __typename?: "FleetAtHomeCurrentElectricityPriceKpi";
    average: string;
    minimum: string;
    maximum: string;
  } | null;
};

export type GetFleetAtHomeWallboxesKpiForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetFleetAtHomeWallboxesKpiForCustomerQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeWallboxesKpiForCustomer: {
    __typename?: "FleetAtHomeWallboxesKpi";
    count: number;
    additionsLastPeriod: number;
  };
};

export type FleetAtHomeUpdateCustomerSettingsMutationVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  customerSettings: FleetAtHomeCustomerSettingsInput;
}>;

export type FleetAtHomeUpdateCustomerSettingsMutation = {
  __typename?: "RootMutationType";
  fleetAtHomeUpdateCustomerSettings: {
    __typename?: "MutationResult";
    errors: Array<MutationError>;
    success: boolean;
    errorDetails?: {
      __typename?: "OperationErrorDetails";
      message?: string | null;
    } | null;
  };
};

export type GetFleetAtHomeCustomerSettingsQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetFleetAtHomeCustomerSettingsQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeCustomerSettings: {
    __typename?: "FleetAtHomeCustomerSettings";
    autoAcceptElectricityPrice?: boolean | null;
    electricityPriceRangeFrom?: string | null;
    electricityPriceRangeTo?: string | null;
    companyIsPaying: boolean;
    electricityPriceCertificateNeeded: boolean;
    electricityPriceVariants: ElectricityPriceVariants;
  };
};

export type FleetAtHomeAcceptProposedElectricityPriceMutationVariables = Exact<{
  stationId: Scalars["ID"]["input"];
}>;

export type FleetAtHomeAcceptProposedElectricityPriceMutation = {
  __typename?: "RootMutationType";
  fleetAtHomeAcceptProposedElectricityPrice: {
    __typename?: "FleetAtHomeAcceptProposedElectricityPriceMutationResult";
    errors: Array<FleetAtHomeAcceptProposedElectricityPriceMutationError>;
    success: boolean;
  };
};

export type FleetAtHomeDeclineProposedElectricityPriceMutationVariables =
  Exact<{
    stationId: Scalars["ID"]["input"];
    reason?: InputMaybe<Scalars["String"]["input"]>;
  }>;

export type FleetAtHomeDeclineProposedElectricityPriceMutation = {
  __typename?: "RootMutationType";
  fleetAtHomeDeclineProposedElectricityPrice: {
    __typename?: "FleetAtHomeDeclineProposedElectricityPriceMutationResult";
    errors: Array<FleetAtHomeDeclineProposedElectricityPriceMutationError>;
    success: boolean;
  };
};

export type GetFleetAtHomeUserDataForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetFleetAtHomeUserDataForCustomerQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeUserDataForCustomer: Array<{
    __typename?: "FleetAtHomeUserData";
    id: string;
    email: string;
    firstName?: string | null;
    lastName: string;
    registrationLink?: string | null;
    state: FleetAtHomeUserState;
    createdAt: any;
    stations: Array<{
      __typename?: "FleetAtHomeStation";
      id: string;
      name: string;
      city: string;
      postalCode: string;
      street: string;
      houseNumber: string;
      currentElectricityPrice?: {
        __typename?: "FleetAtHomeElectricityPrice";
        electricityPricePerKilowattHour: string;
        basicFee?: string | null;
        state: FleetAtHomeElectricityPriceState;
        dateTo?: any | null;
        url?: string | null;
      } | null;
      proposedElectricityPrice?: {
        __typename?: "FleetAtHomeElectricityPrice";
        electricityPricePerKilowattHour: string;
        basicFee?: string | null;
        state: FleetAtHomeElectricityPriceState;
        dateFrom: any;
        createdAt: any;
        url?: string | null;
      } | null;
    }>;
  }>;
};

export type FleetAtHomeInviteUserMutationVariables = Exact<{
  invitationData: InvitationDataInput;
}>;

export type FleetAtHomeInviteUserMutation = {
  __typename?: "RootMutationType";
  fleetAtHomeInviteUser: {
    __typename?: "InviteUserMutationResult";
    errors: Array<InviteUserMutationError>;
    success: boolean;
    caseNumber?: string | null;
  };
};

export type GetFleetAtHomeTransactionQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetFleetAtHomeTransactionQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeTransaction?: {
    __typename?: "FleetAtHomeTransaction";
    id: string;
    startTime: any;
    stopTime?: any | null;
    amount?: string | null;
    energyAmountKilowatthours?: string | null;
    creditState: FleetAtHomeTransactionCreditState;
    isPrivate: boolean;
    station: {
      __typename?: "FleetAtHomeStation";
      id: string;
      name: string;
      alias?: string | null;
      street: string;
      houseNumber: string;
      postalCode: string;
      city: string;
      country: string;
      earliestPossibleElectricityPriceProposal: any;
      provider: string;
      setupNecessary: boolean;
      state: FleetAtHomeStationState;
    };
  } | null;
};

export type GetFleetAtHomeTransactionsQueryVariables = Exact<{
  isPrivate?: InputMaybe<Scalars["Boolean"]["input"]>;
  isCredited?: InputMaybe<Scalars["Boolean"]["input"]>;
  startTime?: InputMaybe<DateFilterInput>;
  energyAmountKilowatthoursFrom?: InputMaybe<Scalars["Decimal"]["input"]>;
  energyAmountKilowatthoursTo?: InputMaybe<Scalars["Decimal"]["input"]>;
  amountFrom?: InputMaybe<Scalars["Decimal"]["input"]>;
  amountTo?: InputMaybe<Scalars["Decimal"]["input"]>;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
}>;

export type GetFleetAtHomeTransactionsQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeTransactions: {
    __typename?: "FleetAtHomeTransactionPage";
    totalAmount: string;
    totalEnergyAmountKilowatthours: string;
    totalDurationMinutes: number;
    transactions: Array<{
      __typename?: "FleetAtHomeTransaction";
      amount?: string | null;
      creditState: FleetAtHomeTransactionCreditState;
      energyAmountKilowatthours?: string | null;
      id: string;
      startTime: any;
      stopTime?: any | null;
      isPrivate: boolean;
      station: {
        __typename?: "FleetAtHomeStation";
        name: string;
        alias?: string | null;
      };
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type GetFleetAtHomeCreditNoteQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetFleetAtHomeCreditNoteQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeCreditNote: {
    __typename?: "FleetAtHomeCreditNote";
    dateFrom: any;
    dateTo: any;
    energyAmountKilowatthours: string;
    forecasted: boolean;
    grossAmountInEuro?: string | null;
    id?: string | null;
    numberOfTransactions: number;
    url?: string | null;
  };
};

export type GetFleetAtHomeCreditNotesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetFleetAtHomeCreditNotesQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeCreditNotes: Array<{
    __typename?: "FleetAtHomeCreditNote";
    dateFrom: any;
    dateTo: any;
    energyAmountKilowatthours: string;
    forecasted: boolean;
    grossAmountInEuro?: string | null;
    id?: string | null;
    numberOfTransactions: number;
    url?: string | null;
  }>;
};

export type GetFleetAtHomeForecastedCreditNotesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetFleetAtHomeForecastedCreditNotesQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeForecastedCreditNotes: Array<{
    __typename?: "FleetAtHomeCreditNote";
    dateFrom: any;
    dateTo: any;
    energyAmountKilowatthours: string;
    forecasted: boolean;
    grossAmountInEuro?: string | null;
    id?: string | null;
    numberOfTransactions: number;
    url?: string | null;
  }>;
};

export type GetFleetAtHomeChargesKpiQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetFleetAtHomeChargesKpiQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeChargesKpi: {
    __typename?: "FleetAtHomeChargesKpi";
    count: {
      __typename?: "FleetAtHomeChargesCountKpiValue";
      averagePreviousThreeMonths: string;
      currentMonth: number;
    };
    averageEnergyAmountKilowatthours: {
      __typename?: "FleetAtHomeChargesEnergyKpiValue";
      averagePreviousThreeMonths: string;
      currentMonth: string;
    };
    currentMonthProgress: {
      __typename?: "FleetAtHomeKpiProgress";
      currentDay: number;
      totalDays: number;
    };
  };
};

export type GetFleetAtHomeCreditedAmountKpiQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetFleetAtHomeCreditedAmountKpiQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeCreditedAmountKpi: {
    __typename?: "FleetAtHomeCreditedAmountKpi";
    grossAmountInEuro: {
      __typename?: "FleetAtHomeCreditedAmountKpiValue";
      averagePreviousThreePeriods: string;
      currentPeriod: string;
    };
    currentPeriodProgress: {
      __typename?: "FleetAtHomeKpiProgress";
      currentDay: number;
      totalDays: number;
    };
  };
};

export type FleetAtHomeShopProductCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FleetAtHomeShopProductCategoriesQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeShopProductCategories: Array<string>;
};

export type FleetAtHomeShopProductsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FleetAtHomeShopProductsQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeShopProducts: Array<{
    __typename?: "FleetAtHomeShopProduct";
    id: string;
    name: string;
    shortDescription: string;
    detailedDescription: string;
    price: string;
    listPrice: string;
    currency: string;
    category: string;
    image?: {
      __typename?: "FleetAtHomeShopProductImage";
      mimeType: string;
      content: string;
    } | null;
  }>;
};

export type FleetAtHomeOrderPreviewQueryVariables = Exact<{
  data: FleetAtHomeOrderPreviewDataInput;
}>;

export type FleetAtHomeOrderPreviewQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeOrderPreview: {
    __typename?: "FleetAtHomeOrderPreview";
    totalAmount: string;
    netAmount: string;
    shipping: string;
    vatAmount: string;
    isCompanyPaymentAllowed: boolean;
    items: Array<{
      __typename?: "FleetAtHomeOrderPreviewItem";
      id: string;
      name: string;
      price: string;
      quantity: string;
    }>;
  };
};

export type FleetAtHomePlaceOrderMutationVariables = Exact<{
  data: FleetAtHomeOrderInput;
}>;

export type FleetAtHomePlaceOrderMutation = {
  __typename?: "RootMutationType";
  fleetAtHomePlaceOrder: {
    __typename?: "FleetAtHomePlaceOrderMutationResult";
    success: boolean;
    errors: Array<FleetAtHomePlaceOrderMutationError>;
  };
};

export type FleetAtHomeShopProductQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type FleetAtHomeShopProductQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeShopProduct: {
    __typename?: "FleetAtHomeShopProduct";
    id: string;
    name: string;
    shortDescription: string;
    detailedDescription: string;
    price: string;
    listPrice: string;
    currency: string;
    category: string;
    image?: {
      __typename?: "FleetAtHomeShopProductImage";
      mimeType: string;
      content: string;
    } | null;
    configurationOptions: Array<{
      __typename?: "FleetAtHomeShopProductAccessory";
      id: string;
      shortDescription: string;
      price: string;
      listPrice: string;
      currency: string;
    }>;
    obligatoryConfigurationOptions: Array<{
      __typename?: "FleetAtHomeShopProductAccessory";
      id: string;
      shortDescription: string;
      price: string;
      listPrice: string;
      currency: string;
    }>;
    accessories: Array<{
      __typename?: "FleetAtHomeShopProductAccessory";
      id: string;
      shortDescription: string;
      price: string;
      listPrice: string;
      currency: string;
    }>;
  };
};

export type FleetAtHomeProposeElectricityPriceMutationVariables = Exact<{
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  electricityPricePerKilowattHour: Scalars["Decimal"]["input"];
  basicFee: Scalars["Decimal"]["input"];
  stationId: Scalars["ID"]["input"];
  electricityPriceCertificateId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type FleetAtHomeProposeElectricityPriceMutation = {
  __typename?: "RootMutationType";
  fleetAtHomeProposeElectricityPrice: {
    __typename?: "FleetAtHomeProposeElectricityPriceMutationResult";
    errors: Array<FleetAtHomeProposeElectricityPriceMutationError>;
    success: boolean;
  };
};

export type FleetAtHomeUpdateStationMutationVariables = Exact<{
  stationId: Scalars["ID"]["input"];
  alias?: InputMaybe<Scalars["String"]["input"]>;
  street?: InputMaybe<Scalars["String"]["input"]>;
  houseNumber?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  flatrateSettlementConditionId?: InputMaybe<Scalars["String"]["input"]>;
  flatrateSettlementIsActive?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type FleetAtHomeUpdateStationMutation = {
  __typename?: "RootMutationType";
  fleetAtHomeUpdateStation: {
    __typename?: "FleetAtHomeUpdateStationMutationResult";
    errors: Array<FleetAtHomeUpdateStationMutationError>;
    success: boolean;
    errorDetails?: {
      __typename?: "OperationErrorDetails";
      message?: string | null;
    } | null;
  };
};

export type FleetAtHomeWithdrawElectricityPriceMutationVariables = Exact<{
  stationId: Scalars["ID"]["input"];
}>;

export type FleetAtHomeWithdrawElectricityPriceMutation = {
  __typename?: "RootMutationType";
  fleetAtHomeWithdrawProposedElectricityPrice: {
    __typename?: "MutationResult";
    errors: Array<MutationError>;
    success: boolean;
  };
};

export type GetFleetAtHomeElectricityPriceHistoryForStationQueryVariables =
  Exact<{
    stationId: Scalars["ID"]["input"];
  }>;

export type GetFleetAtHomeElectricityPriceHistoryForStationQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeElectricityPriceHistoryForStation: Array<{
    __typename?: "FleetAtHomeElectricityPrice";
    id: string;
    createdAt: any;
    dateFrom: any;
    dateTo?: any | null;
    electricityPricePerKilowattHour: string;
    basicFee?: string | null;
    state: FleetAtHomeElectricityPriceState;
    reason?: string | null;
    url?: string | null;
  }>;
};

export type GetFleetAtHomeFlatrateElectricityPriceQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetFleetAtHomeFlatrateElectricityPriceQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeFlatrateElectricityPrice?: {
    __typename?: "FleetAtHomeFlatrateElectricityPrice";
    dateFrom: any;
    dateTo: any;
    electricityPricePerKilowattHour: string;
    conditionId: string;
  } | null;
};

export type GetFleetAtHomeStationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetFleetAtHomeStationsQuery = {
  __typename?: "RootQueryType";
  fleetAtHomeStations: Array<{
    __typename?: "FleetAtHomeStation";
    id: string;
    setupNecessary: boolean;
    name: string;
    alias?: string | null;
    street: string;
    houseNumber: string;
    postalCode: string;
    city: string;
    country: string;
    state: FleetAtHomeStationState;
    earliestPossibleElectricityPriceProposal: any;
    currentElectricityPrice?: {
      __typename?: "FleetAtHomeElectricityPrice";
      createdAt: any;
      electricityPricePerKilowattHour: string;
      basicFee?: string | null;
      state: FleetAtHomeElectricityPriceState;
      dateFrom: any;
      url?: string | null;
    } | null;
    proposedElectricityPrice?: {
      __typename?: "FleetAtHomeElectricityPrice";
      createdAt: any;
      electricityPricePerKilowattHour: string;
      basicFee?: string | null;
      state: FleetAtHomeElectricityPriceState;
      dateFrom: any;
      reason?: string | null;
      url?: string | null;
    } | null;
    order?: {
      __typename?: "FleetAtHomeOrder";
      id: string;
      invoiceUrl: string;
      netAmount: string;
      state: string;
      totalAmount: string;
      trackingNumber?: string | null;
      vatAmount: string;
    } | null;
  }>;
};

export type FinishRegistrationMutationVariables = Exact<{
  address: AddressInput;
}>;

export type FinishRegistrationMutation = {
  __typename?: "RootMutationType";
  finishRegistration: {
    __typename?: "MutationResult";
    errors: Array<MutationError>;
    success: boolean;
  };
};

export type GetActiveMaintenanceQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetActiveMaintenanceQuery = {
  __typename?: "RootQueryType";
  activeMaintenance?: {
    __typename?: "Maintenance";
    dateFrom: any;
    dateTo?: any | null;
  } | null;
};

export type CustomerManagementRegisterInvitedUserMutationVariables = Exact<{
  registrationData: CustomerManagementRegistrationDataInput;
}>;

export type CustomerManagementRegisterInvitedUserMutation = {
  __typename?: "RootMutationType";
  customerManagementRegisterInvitedUser: {
    __typename?: "CustomerManagementRegisterUserMutationResult";
    caseNumber?: string | null;
    registrationFinished: boolean;
    success: boolean;
    errors: Array<CustomerManagementRegisterUserMutationError>;
  };
};

export type GetRegistrationDataQueryVariables = Exact<{
  provisioningKey: Scalars["String"]["input"];
  registrationType?: InputMaybe<RegistrationType>;
}>;

export type GetRegistrationDataQuery = {
  __typename?: "RootQueryType";
  registrationData?: {
    __typename?: "RegistrationDataResult";
    errors: Array<RegistrationDataError>;
    success: boolean;
    registrationData?: {
      __typename?: "RegistrationData";
      salutation?: Salutation | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      finishedRegistration?: boolean | null;
    } | null;
  } | null;
};

export type RegisterFleetAtHomeUserMutationVariables = Exact<{
  registrationData: FleetAtHomeRegistrationDataInput;
}>;

export type RegisterFleetAtHomeUserMutation = {
  __typename?: "RootMutationType";
  registerFleetAtHomeUser: {
    __typename?: "RegisterFleetAtHomeUserMutationResult";
    passwordSet?: boolean | null;
    success: boolean;
    errors: Array<RegisterFleetAtHomeUserMutationError>;
  };
};

export type RegisterExistingCustomerMutationVariables = Exact<{
  registrationData: RegisterExistingCustomerInput;
}>;

export type RegisterExistingCustomerMutation = {
  __typename?: "RootMutationType";
  registerExistingCustomer: {
    __typename?: "RegisterExistingCustomerMutationResult";
    caseNumber?: string | null;
    errors: Array<RegisterExistingCustomerMutationError>;
    success: boolean;
  };
};

export type RegisterUserMutationVariables = Exact<{
  registrationData: RegistrationDataInput;
}>;

export type RegisterUserMutation = {
  __typename?: "RootMutationType";
  registerUser: {
    __typename?: "RegisterUserMutationResult";
    success: boolean;
    errors: Array<RegisterUserMutationError>;
  };
};

export type VerifyEmailMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
}>;

export type VerifyEmailMutation = {
  __typename?: "RootMutationType";
  verifyEmail: {
    __typename?: "VerifyEmailMutationResult";
    passwordSet?: boolean | null;
    success: boolean;
    errors: Array<VerifyEmailMutationError>;
  };
};

export type ThgQuotePreregisterVehicleMutationVariables = Exact<{
  data: ThgQuotePendingVehicleRegistrationInput;
}>;

export type ThgQuotePreregisterVehicleMutation = {
  __typename?: "RootMutationType";
  thgQuotePreregisterVehicle: {
    __typename?: "ThgQuotePendingVehicleRegistrationMutationResult";
    errors: Array<ThgQuotePendingVehicleRegistrationMutationError>;
    success: boolean;
    pendingVehicleRegistrationId?: string | null;
  };
};

export type GetThgQuoteVehicleRegistrationsForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetThgQuoteVehicleRegistrationsForCustomerQuery = {
  __typename?: "RootQueryType";
  thgQuoteVehicleRegistrationsForCustomer: Array<{
    __typename?: "ThgQuoteVehicleRegistration";
    id: string;
    state: ThgQuoteVehicleRegistrationState;
    vehicleAlias: string;
    vehicleClass: string;
    vehicleOwner?: string | null;
    year: string;
    fin?: string | null;
    creationDate: any;
    validForResubmission: boolean;
  }>;
};

export type ThgQuoteResubmitVehicleRegistrationsMutationVariables = Exact<{
  applicationIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  customerId: Scalars["ID"]["input"];
}>;

export type ThgQuoteResubmitVehicleRegistrationsMutation = {
  __typename?: "RootMutationType";
  thgQuoteResubmitVehicleRegistrations: {
    __typename?: "ThgQuoteResubmitVehicleRegistrationMutationResult";
    success: boolean;
    errors: Array<MutationError>;
    results: Array<{
      __typename?: "ThgQuoteResubmitVehicleRegistrationResult";
      id: string;
      error?: MutationError | null;
      success: boolean;
    }>;
  };
};

export type ThgQuoteDeletePendingVehicleRegistrationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ThgQuoteDeletePendingVehicleRegistrationMutation = {
  __typename?: "RootMutationType";
  thgQuoteDeletePendingVehicleRegistration: {
    __typename?: "ThgQuoteDeletePendingVehicleRegistrationMutationResult";
    success: boolean;
    errors: Array<ThgQuoteDeletePendingVehicleRegistrationMutationError>;
  };
};

export type ThgQuoteRegisterVehicleMutationVariables = Exact<{
  data: ThgQuoteVehicleRegistrationInput;
}>;

export type ThgQuoteRegisterVehicleMutation = {
  __typename?: "RootMutationType";
  thgQuoteRegisterVehicle: {
    __typename?: "ThgQuoteVehicleRegistrationMutationResult";
    success: boolean;
    errors: Array<ThgQuoteVehicleRegistrationMutationError>;
  };
};

export type ThgQuoteVehicleRegistrationInfoQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type ThgQuoteVehicleRegistrationInfoQuery = {
  __typename?: "RootQueryType";
  thgQuoteVehicleRegistrationInfo: {
    __typename?: "ThgQuoteVehicleRegistrationInfo";
    addressDetailsNecessary: boolean;
    vatIdentificationNumberNecessary: boolean;
  };
};

export type WccReactivateCardsMutationVariables = Exact<{
  cardNumbers: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  customerId: Scalars["ID"]["input"];
}>;

export type WccReactivateCardsMutation = {
  __typename?: "RootMutationType";
  wccReactivateCards: {
    __typename?: "WccCardMutationResult";
    success: boolean;
    errors: Array<WccCardMutationError>;
    cardResults: Array<{
      __typename?: "WccCardUpdateResult";
      cardNr: string;
      error?: WccCardUpdateResultError | null;
      success: boolean;
    }>;
  };
};

export type ActivateCardSubscriptionsMutationVariables = Exact<{
  cardSubscriptions: Array<WccCardSubscriptionInput> | WccCardSubscriptionInput;
  customerId: Scalars["ID"]["input"];
}>;

export type ActivateCardSubscriptionsMutation = {
  __typename?: "RootMutationType";
  wccActivateCardSubscriptions: {
    __typename?: "WccCardMutationResult";
    errors: Array<WccCardMutationError>;
    success: boolean;
    cardResults: Array<{
      __typename?: "WccCardUpdateResult";
      cardNr: string;
      error?: WccCardUpdateResultError | null;
      success: boolean;
    }>;
  };
};

export type WccChargeCardsMutationVariables = Exact<{
  cardCharges: Array<WccCardChargeInput> | WccCardChargeInput;
  customerId: Scalars["ID"]["input"];
}>;

export type WccChargeCardsMutation = {
  __typename?: "RootMutationType";
  wccChargeCards: {
    __typename?: "WccCardMutationResult";
    errors: Array<WccCardMutationError>;
    success: boolean;
    cardResults: Array<{
      __typename?: "WccCardUpdateResult";
      cardNr: string;
      error?: WccCardUpdateResultError | null;
      success: boolean;
    }>;
  };
};

export type GetWccChargeHistoryForCardQueryVariables = Exact<{
  cardNr: Scalars["ID"]["input"];
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
}>;

export type GetWccChargeHistoryForCardQuery = {
  __typename?: "RootQueryType";
  wccChargeHistoryForCard: {
    __typename?: "WccChargePage";
    charges: Array<{
      __typename?: "WccCharge";
      amount: string;
      chargedAt: any;
      type: WccChargeType;
      cardNr: string;
      label: string;
      isCancelable: boolean;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type DeactivateCardSubscriptionsMutationVariables = Exact<{
  cardNumbers: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  customerId: Scalars["ID"]["input"];
}>;

export type DeactivateCardSubscriptionsMutation = {
  __typename?: "RootMutationType";
  wccDeactivateCardSubscriptions: {
    __typename?: "WccCardMutationResult";
    errors: Array<WccCardMutationError>;
    success: boolean;
    cardResults: Array<{
      __typename?: "WccCardUpdateResult";
      cardNr: string;
      error?: WccCardUpdateResultError | null;
      success: boolean;
    }>;
  };
};

export type WccDeactivateCardsMutationVariables = Exact<{
  cardNumbers: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  customerId: Scalars["ID"]["input"];
}>;

export type WccDeactivateCardsMutation = {
  __typename?: "RootMutationType";
  wccDeactivateCards: {
    __typename?: "WccCardMutationResult";
    success: boolean;
    errors: Array<WccCardMutationError>;
    cardResults: Array<{
      __typename?: "WccCardUpdateResult";
      cardNr: string;
      error?: WccCardUpdateResultError | null;
      success: boolean;
    }>;
  };
};

export type WccPlaceCardOrderMutationVariables = Exact<{
  orderData: WccOrderDataInput;
}>;

export type WccPlaceCardOrderMutation = {
  __typename?: "RootMutationType";
  wccPlaceCardOrder: {
    __typename?: "WccPlaceCardOrderMutationResult";
    success: boolean;
    errors: Array<WccPlaceCardOrderMutationError>;
  };
};

export type WccUpdateCardLabelsMutationVariables = Exact<{
  cardLabels: Array<WccCardLabelInput> | WccCardLabelInput;
  customerId: Scalars["ID"]["input"];
}>;

export type WccUpdateCardLabelsMutation = {
  __typename?: "RootMutationType";
  wccUpdateCardLabels: {
    __typename?: "WccCardMutationResult";
    success: boolean;
    errors: Array<WccCardMutationError>;
    cardResults: Array<{
      __typename?: "WccCardUpdateResult";
      cardNr: string;
      error?: WccCardUpdateResultError | null;
      success: boolean;
    }>;
  };
};

export type WccUpdateCardSubscriptionAmountsMutationVariables = Exact<{
  cardSubscriptions: Array<WccCardSubscriptionInput> | WccCardSubscriptionInput;
  customerId: Scalars["ID"]["input"];
}>;

export type WccUpdateCardSubscriptionAmountsMutation = {
  __typename?: "RootMutationType";
  wccUpdateCardSubscriptionAmounts: {
    __typename?: "WccCardMutationResult";
    success: boolean;
    errors: Array<WccCardMutationError>;
    cardResults: Array<{
      __typename?: "WccCardUpdateResult";
      cardNr: string;
      error?: WccCardUpdateResultError | null;
      success: boolean;
    }>;
  };
};

export type WccUpdateCardSubscriptionTermsMutationVariables = Exact<{
  cardSubscriptionTerms:
    | Array<WccCardSubscriptionTermInput>
    | WccCardSubscriptionTermInput;
  customerId: Scalars["ID"]["input"];
}>;

export type WccUpdateCardSubscriptionTermsMutation = {
  __typename?: "RootMutationType";
  wccUpdateCardSubscriptionTerms: {
    __typename?: "WccCardMutationResult";
    success: boolean;
    errors: Array<WccCardMutationError>;
    cardResults: Array<{
      __typename?: "WccCardUpdateResult";
      cardNr: string;
      error?: WccCardUpdateResultError | null;
      success: boolean;
    }>;
  };
};

export type GetWccChargeHistoryForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
  types?: InputMaybe<Array<WccChargeType> | WccChargeType>;
  amountFrom?: InputMaybe<Scalars["Decimal"]["input"]>;
  amountTo?: InputMaybe<Scalars["Decimal"]["input"]>;
}>;

export type GetWccChargeHistoryForCustomerQuery = {
  __typename?: "RootQueryType";
  wccChargeHistoryForCustomer: {
    __typename?: "WccChargesForCustomerPage";
    downloadLink: string;
    charges: Array<{
      __typename?: "WccCharge";
      amount: string;
      cardNr: string;
      chargedAt: any;
      label: string;
      type: WccChargeType;
      isCancelable: boolean;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type GetWccInvoiceQueryVariables = Exact<{
  invoiceId: Scalars["ID"]["input"];
}>;

export type GetWccInvoiceQuery = {
  __typename?: "RootQueryType";
  wccInvoice: {
    __typename?: "WccInvoice";
    id: string;
    invoicedAt: any;
    netValue: string;
    documentAvailable: boolean;
    url?: string | null;
  };
};

export type GetWccInvoicesForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
}>;

export type GetWccInvoicesForCustomerQuery = {
  __typename?: "RootQueryType";
  wccInvoicesForCustomer: {
    __typename?: "WccInvoicePage";
    invoices: Array<{
      __typename?: "WccInvoice";
      id: string;
      invoicedAt: any;
      netValue: string;
      documentAvailable: boolean;
      url?: string | null;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type GetWccOrderQueryVariables = Exact<{
  orderId: Scalars["ID"]["input"];
}>;

export type GetWccOrderQuery = {
  __typename?: "RootQueryType";
  wccOrder: {
    __typename?: "WccOrder";
    createdAt: any;
    orderNumber: string;
    state: WccOrderState;
    batch1?: {
      __typename?: "WccOrderBatch";
      cardQuantity: number;
      subscriptionAmount: string;
    } | null;
    batch2?: {
      __typename?: "WccOrderBatch";
      cardQuantity: number;
      subscriptionAmount: string;
    } | null;
    batch3?: {
      __typename?: "WccOrderBatch";
      cardQuantity: number;
      subscriptionAmount: string;
    } | null;
    cards?: Array<{
      __typename?: "WccCard";
      archivedAt?: any | null;
      cardNr: string;
      label: string;
      lastChargedAt?: any | null;
      reloadCount?: number | null;
      state: WccCardState;
      subscriptionAmount: string;
      subscriptionState: WccSubscriptionState;
      totalAmountPerPeriod: string;
    }> | null;
  };
};

export type GetWccOrdersForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  states?: InputMaybe<Array<WccOrderState> | WccOrderState>;
}>;

export type GetWccOrdersForCustomerQuery = {
  __typename?: "RootQueryType";
  wccOrdersForCustomer: {
    __typename?: "WccOrderPage";
    orders: Array<{
      __typename?: "WccOrder";
      createdAt: any;
      orderNumber: string;
      state: WccOrderState;
      batch1?: {
        __typename?: "WccOrderBatch";
        cardQuantity: number;
        subscriptionAmount: string;
      } | null;
      batch2?: {
        __typename?: "WccOrderBatch";
        cardQuantity: number;
        subscriptionAmount: string;
      } | null;
      batch3?: {
        __typename?: "WccOrderBatch";
        cardQuantity: number;
        subscriptionAmount: string;
      } | null;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type GetWccCardsForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<WccCardState>;
  subscriptionStates?: InputMaybe<
    Array<WccSubscriptionState> | WccSubscriptionState
  >;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  sortParams?: InputMaybe<WccCardSortInput>;
}>;

export type GetWccCardsForCustomerQuery = {
  __typename?: "RootQueryType";
  wccCardsForCustomer: {
    __typename?: "WccCardPage";
    cards: Array<{
      __typename?: "WccCard";
      archivedAt?: any | null;
      cardNr: string;
      label: string;
      lastChargedAt?: any | null;
      reloadCount?: number | null;
      state: WccCardState;
      subscriptionAmount: string;
      subscriptionState: WccSubscriptionState;
      subscriptionActiveFrom?: any | null;
      subscriptionActiveUntil?: any | null;
      totalAmountPerPeriod: string;
      orderId?: string | null;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type WccCancelCardChargesMutationVariables = Exact<{
  cardNumbers: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  customerId: Scalars["ID"]["input"];
}>;

export type WccCancelCardChargesMutation = {
  __typename?: "RootMutationType";
  wccCancelCardCharges: {
    __typename?: "WccCardMutationResult";
    success: boolean;
    errors: Array<WccCardMutationError>;
    cardResults: Array<{
      __typename?: "WccCardUpdateResult";
      cardNr: string;
      error?: WccCardUpdateResultError | null;
      success: boolean;
    }>;
  };
};

export type CustomerManagementGenerateInvitationLinkMutationVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  serviceRoles: Array<ServiceRole> | ServiceRole;
  maximumRegistrations: Scalars["Int"]["input"];
  validUntil: Scalars["DateTime"]["input"];
  needsReview: Scalars["Boolean"]["input"];
}>;

export type CustomerManagementGenerateInvitationLinkMutation = {
  __typename?: "RootMutationType";
  customerManagementGenerateInvitationLink: {
    __typename?: "GenerateInvitationLinkMutationResult";
    success: boolean;
    errors: Array<GenerateInvitationLinkMutationError>;
    invitationLink?: string | null;
  };
};

export type GetInvitationsQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
}>;

export type GetInvitationsQuery = {
  __typename?: "RootQueryType";
  customerManagementInvitations: {
    __typename?: "CustomerManagementInvitationsPage";
    invitations: Array<{
      __typename?: "CustomerManagementInvitation";
      id: string;
      name?: string | null;
      maximumRegistrations: number;
      validUntil: any;
      createdAt: any;
      invitationLink: string;
      status: CustomerManagementInvitationState;
      needsReview: boolean;
      registrations: Array<{
        __typename?: "CustomerManagementRegistration";
        id: string;
        email: string;
        firstName?: string | null;
        lastName: string;
        salutation?: Salutation | null;
        status: CustomerManagementRegistrationState;
        caseNumber?: string | null;
        createdAt: any;
        updatedAt: any;
      }>;
      servicesWithRoles: Array<{
        __typename?: "CustomerManagementService";
        id: ServiceSubscription;
        name: string;
        serviceRoles: Array<{
          __typename?: "CustomerManagementServiceRole";
          id: ServiceRole;
          name: string;
        }>;
      }>;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type CustomerManagementReviewRegistrationMutationVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  registrationId: Scalars["ID"]["input"];
  reviewOutcome: CustomerManagementRegistrationReviewOptions;
}>;

export type CustomerManagementReviewRegistrationMutation = {
  __typename?: "RootMutationType";
  customerManagementReviewRegistration: {
    __typename?: "CustomerManagementReviewRegistrationResult";
    success: boolean;
    errors: Array<CustomerManagementReviewRegistrationError>;
    caseNumber?: string | null;
  };
};

export type CustomerManagementUpdateInvitationMutationVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  invitationId: Scalars["ID"]["input"];
  updateData: UpdateInvitationInput;
}>;

export type CustomerManagementUpdateInvitationMutation = {
  __typename?: "RootMutationType";
  customerManagementUpdateInvitation: {
    __typename?: "MutationResult";
    success: boolean;
    errors: Array<MutationError>;
  };
};

export type GetCustomerManagementCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetCustomerManagementCustomerQuery = {
  __typename?: "RootQueryType";
  customerManagementCustomer: {
    __typename?: "CustomerManagementCustomer";
    id: string;
    name: string;
    name2?: string | null;
    customerNumber?: string | null;
    address?: {
      __typename?: "CustomerManagementCustomerAddress";
      street?: string | null;
      city?: string | null;
      postalCode?: string | null;
      country?: string | null;
    } | null;
    serviceSubscriptions: Array<{
      __typename?: "CustomerManagementService";
      id: ServiceSubscription;
      name: string;
      serviceRoles: Array<{
        __typename?: "CustomerManagementServiceRole";
        id: ServiceRole;
        name: string;
      }>;
    }>;
  };
};

export type CustomerManagementSupportCasesForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
}>;

export type CustomerManagementSupportCasesForCustomerQuery = {
  __typename?: "RootQueryType";
  customerManagementSupportCasesForCustomer: {
    __typename?: "SupportCasePage";
    supportCases: Array<{
      __typename?: "SupportCase";
      id: string;
      caseNumber: string;
      userId: string;
      userFirstName?: string | null;
      userLastName: string;
      customerNumber: string;
      customerName: string;
      createdAt: any;
      subject: string;
      description?: string | null;
      category?: string | null;
      businessArea?: string | null;
      state: SupportCaseState;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type CustomerManagementInviteUserMutationVariables = Exact<{
  invitationData: InvitationDataInput;
  serviceRoles: Array<ServiceRole> | ServiceRole;
}>;

export type CustomerManagementInviteUserMutation = {
  __typename?: "RootMutationType";
  customerManagementInviteUser: {
    __typename?: "InviteUserMutationResult";
    success: boolean;
    errors: Array<InviteUserMutationError>;
    invitationResult?: InvitationResult | null;
    caseNumber?: string | null;
  };
};

export type CustomerManagementUpdateUserPermissionsMutationVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
  serviceRoles: Array<ServiceRole> | ServiceRole;
}>;

export type CustomerManagementUpdateUserPermissionsMutation = {
  __typename?: "RootMutationType";
  customerManagementUpdateUserPermissions: {
    __typename?: "CustomerManagementUpdateUserPermissionsResult";
    success: boolean;
    errors: Array<CustomerManagementUpdateUserPermissionsError>;
  };
};

export type GetCustomerManagementUserDataForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  states?: InputMaybe<
    Array<CustomerManagementUserState> | CustomerManagementUserState
  >;
  services?: InputMaybe<Array<ServiceSubscription> | ServiceSubscription>;
}>;

export type GetCustomerManagementUserDataForCustomerQuery = {
  __typename?: "RootQueryType";
  customerManagementUserDataForCustomer: {
    __typename?: "CustomerManagementUserDataPage";
    userData: Array<{
      __typename?: "CustomerManagementUserData";
      id: string;
      state: CustomerManagementUserState;
      salutation?: Salutation | null;
      firstName?: string | null;
      email: string;
      lastName: string;
      registrationLink?: string | null;
      createdAt: any;
      servicesWithRoles: Array<{
        __typename?: "CustomerManagementService";
        id: ServiceSubscription;
        name: string;
        serviceRoles: Array<{
          __typename?: "CustomerManagementServiceRole";
          id: ServiceRole;
          name: string;
        }>;
      }>;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type GetWscCardQueryVariables = Exact<{
  cardNr: Scalars["ID"]["input"];
}>;

export type GetWscCardQuery = {
  __typename?: "RootQueryType";
  wscCard: {
    __typename?: "WscCard";
    acceptanceType: WscCardAcceptanceType;
    additionalText?: string | null;
    bookingText?: string | null;
    cardNr: string;
    decryptedCardPin?: string | null;
    costCenter?: string | null;
    electricityCardEnabled: boolean;
    expiresAt: string;
    gasStationId?: string | null;
    gasStation?: string | null;
    label: string;
    licensePlate?: string | null;
    permissionLevel: WscCardPermissionLevel;
    permissionProductIds: Array<string>;
    requestInfoEntry: boolean;
    requestKilometresEntry: boolean;
    state: WscCardState;
    maxTransactionsPerDay: number;
    virtualCardEnabled: boolean;
    futureBlockDate?: any | null;
    electricityCardInformation?: {
      __typename?: "WscCardElectricityCardInformation";
      email?: string | null;
    } | null;
    virtualCardInformation?: {
      __typename?: "WscCardVirtualCardInformation";
      appIdentification: WscCardVirtualAppIdentification;
      contactType: WscCardVirtualContactType;
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phoneNumber?: string | null;
      salutation?: Salutation | null;
    } | null;
    alternativeShippingAddress?: {
      __typename?: "WscCardAddress";
      addition?: string | null;
      city: string;
      country: string;
      name: string;
      postalCode: string;
      street: string;
    } | null;
    customer?: {
      __typename?: "WscCustomer";
      id: string;
      usedSalesVolumeInCurrentBillingPeriod: string;
      openSalesVolumeInCurrentBillingPeriod: string;
      salesLimitPerBillingPeriod: string;
      shippingAddress: {
        __typename?: "WscCardAddress";
        addition?: string | null;
        city: string;
        country: string;
        name: string;
        postalCode: string;
        street: string;
      };
    } | null;
  };
};

export type GetWscCardPermissionProductsQueryVariables = Exact<{
  lang?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetWscCardPermissionProductsQuery = {
  __typename?: "RootQueryType";
  wscCardPermissionProducts: Array<{
    __typename?: "WscPermissionProduct";
    id: string;
    label: string;
  }>;
};

export type GetWscCardsForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  cardStates?: InputMaybe<Array<WscCardState> | WscCardState>;
  individualPermissionIds?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
}>;

export type GetWscCardsForCustomerQuery = {
  __typename?: "RootQueryType";
  wscCardsForCustomer: {
    __typename?: "WscCardPage";
    downloadLink: string;
    cards: Array<{
      __typename?: "WscCard";
      acceptanceType: WscCardAcceptanceType;
      additionalText?: string | null;
      bookingText?: string | null;
      cardNr: string;
      costCenter?: string | null;
      electricityCardEnabled: boolean;
      expiresAt: string;
      gasStation?: string | null;
      label: string;
      licensePlate?: string | null;
      permissionLevel: WscCardPermissionLevel;
      permissionProductIds: Array<string>;
      requestInfoEntry: boolean;
      requestKilometresEntry: boolean;
      state: WscCardState;
      maxTransactionsPerDay: number;
      virtualCardEnabled: boolean;
      electricityCardInformation?: {
        __typename?: "WscCardElectricityCardInformation";
        email?: string | null;
      } | null;
      virtualCardInformation?: {
        __typename?: "WscCardVirtualCardInformation";
        appIdentification: WscCardVirtualAppIdentification;
        contactType: WscCardVirtualContactType;
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber?: string | null;
        salutation?: Salutation | null;
      } | null;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type WscDeactivatedCardMutationVariables = Exact<{
  cardNr: Scalars["ID"]["input"];
  futureBlockDate?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type WscDeactivatedCardMutation = {
  __typename?: "RootMutationType";
  wscDeactivateCard: {
    __typename?: "WscMutationResult";
    success: boolean;
    errors: Array<WscMutationError>;
  };
};

export type WscPlaceCardOrderMutationVariables = Exact<{
  orderData: WscOrderDataInput;
}>;

export type WscPlaceCardOrderMutation = {
  __typename?: "RootMutationType";
  wscPlaceCardOrder: {
    __typename?: "WscCardMutationResult";
    success: boolean;
    errors: Array<WscCardMutationError>;
  };
};

export type WscReplaceCardMutationVariables = Exact<{
  cardNr: Scalars["ID"]["input"];
  replacementType: WscReplacementType;
  alternativeShippingAddress?: InputMaybe<WscAddressInput>;
}>;

export type WscReplaceCardMutation = {
  __typename?: "RootMutationType";
  wscPlaceReplacementCardOrder: {
    __typename?: "WscMutationResult";
    success: boolean;
    errors: Array<WscMutationError>;
  };
};

export type WscRevokeFutureCardDeactivationMutationVariables = Exact<{
  cardNr: Scalars["ID"]["input"];
}>;

export type WscRevokeFutureCardDeactivationMutation = {
  __typename?: "RootMutationType";
  wscRevokeFutureCardDeactivation: {
    __typename?: "WscMutationResult";
    success: boolean;
    errors: Array<WscMutationError>;
  };
};

export type WscSendVirtualCardActivationLinkMutationVariables = Exact<{
  cardNr: Scalars["ID"]["input"];
}>;

export type WscSendVirtualCardActivationLinkMutation = {
  __typename?: "RootMutationType";
  wscSendVirtualCardActivationLink: {
    __typename?: "WscSendVirtualCardActivationLinkMutationResult";
    success: boolean;
    errors: Array<WscSendVirtualCardActivationLinkMutationError>;
  };
};

export type GetWscStationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetWscStationsQuery = {
  __typename?: "RootQueryType";
  wscStations: Array<{ __typename?: "WscStation"; id: string; label: string }>;
};

export type WscUpdateCardMutationVariables = Exact<{
  cardNr: Scalars["ID"]["input"];
  updateCardData: WscCardUpdateInput;
}>;

export type WscUpdateCardMutation = {
  __typename?: "RootMutationType";
  wscUpdateCard: {
    __typename?: "WscCardMutationResult";
    success: boolean;
    errors: Array<WscCardMutationError>;
  };
};

export type GetWscInvoiceQueryVariables = Exact<{
  invoiceId: Scalars["ID"]["input"];
}>;

export type GetWscInvoiceQuery = {
  __typename?: "RootQueryType";
  wscInvoice: {
    __typename?: "WscInvoice";
    id: string;
    invoicedAt: any;
    grossValue: string;
    documentAvailable: boolean;
    url?: string | null;
  };
};

export type GetWscInvoicesForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
}>;

export type GetWscInvoicesForCustomerQuery = {
  __typename?: "RootQueryType";
  wscInvoicesForCustomer: {
    __typename?: "WscInvoicePage";
    invoices: Array<{
      __typename?: "WscInvoice";
      id: string;
      invoicedAt: any;
      grossValue: string;
      documentAvailable: boolean;
      url?: string | null;
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type GetWscIndividualCustomerPermissionsQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  includeUsageData: Scalars["Boolean"]["input"];
}>;

export type GetWscIndividualCustomerPermissionsQuery = {
  __typename?: "RootQueryType";
  wscIndividualCustomerPermissions: Array<{
    __typename?: "WscIndividualCustomerPermission";
    id: string;
    label: string;
    permissionProductIds: Array<string>;
    usageCount?: number;
  }>;
};

export type WscCreateIndividualCustomerPermissionMutationVariables = Exact<{
  permissionData: WscIndividualCustomerPermissionCreateInput;
}>;

export type WscCreateIndividualCustomerPermissionMutation = {
  __typename?: "RootMutationType";
  wscCreateIndividualCustomerPermission: {
    __typename?: "WscMutationResult";
    success: boolean;
    errors: Array<WscMutationError>;
  };
};

export type WscDeleteIndividualCustomerPermissionMutationVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  permissionId: Scalars["ID"]["input"];
}>;

export type WscDeleteIndividualCustomerPermissionMutation = {
  __typename?: "RootMutationType";
  wscDeleteIndividualCustomerPermission: {
    __typename?: "WscMutationResult";
    success: boolean;
    errors: Array<WscMutationError>;
  };
};

export type WscUpdateIndividualCustomerPermissionMutationVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  permissionId: Scalars["ID"]["input"];
  updatePermissionData: WscIndividualCustomerPermissionUpdateInput;
}>;

export type WscUpdateIndividualCustomerPermissionMutation = {
  __typename?: "RootMutationType";
  wscUpdateIndividualCustomerPermission: {
    __typename?: "WscMutationResult";
    success: boolean;
    errors: Array<WscMutationError>;
  };
};

export type GetWscCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetWscCustomerQuery = {
  __typename?: "RootQueryType";
  wscCustomer: {
    __typename?: "WscCustomer";
    id: string;
    usedSalesVolumeInCurrentBillingPeriod: string;
    openSalesVolumeInCurrentBillingPeriod: string;
    salesLimitPerBillingPeriod: string;
    shippingAddress: {
      __typename?: "WscCardAddress";
      addition?: string | null;
      city: string;
      country: string;
      name: string;
      postalCode: string;
      street: string;
    };
  };
};

export type GetWscTransactionQueryVariables = Exact<{
  transactionId: Scalars["ID"]["input"];
}>;

export type GetWscTransactionQuery = {
  __typename?: "RootQueryType";
  wscTransaction: {
    __typename?: "WscTransaction";
    receiptNr: string;
    createdAt: any;
    gasStation: string;
    street: string;
    postalCode: string;
    city: string;
    goodsGroup: string;
    quantity: string;
    unit: string;
    currency: string;
    grossValue: string;
    mileage?: number | null;
    info?: string | null;
    card?: {
      __typename?: "WscCard";
      acceptanceType: WscCardAcceptanceType;
      additionalText?: string | null;
      bookingText?: string | null;
      cardNr: string;
      costCenter?: string | null;
      decryptedCardPin?: string | null;
      electricityCardEnabled: boolean;
      expiresAt: string;
      gasStation?: string | null;
      label: string;
      licensePlate?: string | null;
      permissionLevel: WscCardPermissionLevel;
      permissionProductIds: Array<string>;
      requestInfoEntry: boolean;
      requestKilometresEntry: boolean;
      state: WscCardState;
      maxTransactionsPerDay: number;
      virtualCardEnabled: boolean;
      virtualCardInformation?: {
        __typename?: "WscCardVirtualCardInformation";
        appIdentification: WscCardVirtualAppIdentification;
        contactType: WscCardVirtualContactType;
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber?: string | null;
        salutation?: Salutation | null;
      } | null;
      alternativeShippingAddress?: {
        __typename?: "WscCardAddress";
        addition?: string | null;
        city: string;
        country: string;
        name: string;
        postalCode: string;
        street: string;
      } | null;
    } | null;
  };
};

export type GetWscGoodsGroupsQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetWscGoodsGroupsQuery = {
  __typename?: "RootQueryType";
  wscGoodsGroups: Array<string>;
};

export type GetWscTransactionsForCustomerQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  goodsGroups?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  grossValueFrom?: InputMaybe<Scalars["Decimal"]["input"]>;
  grossValueTo?: InputMaybe<Scalars["Decimal"]["input"]>;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
}>;

export type GetWscTransactionsForCustomerQuery = {
  __typename?: "RootQueryType";
  wscTransactionsForCustomer: {
    __typename?: "WscTransactionPage";
    downloadLink: string;
    transactions: Array<{
      __typename?: "WscTransaction";
      id: string;
      createdAt: any;
      gasStation: string;
      street: string;
      postalCode: string;
      city: string;
      quantity: string;
      goodsGroup: string;
      grossValue: string;
      currency: string;
      unit: string;
      transactionCardData: {
        __typename?: "WscTransactionCardData";
        cardNr: string;
        label: string;
      };
    }>;
    paginationMetadata: {
      __typename?: "PaginationMetadata";
      page: number;
      pageSize: number;
      totalEntries: number;
      totalPages: number;
    };
  };
};

export type ClearCurrentUserCachedPermissionsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ClearCurrentUserCachedPermissionsMutation = {
  __typename?: "RootMutationType";
  clearCurrentUserCachedPermissions: {
    __typename?: "MutationResult";
    success: boolean;
    errors: Array<MutationError>;
  };
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = {
  __typename?: "RootQueryType";
  currentUserV2: {
    __typename?: "CurrentUserQueryResult";
    success: boolean;
    errors: Array<CurrentUserQueryError>;
    user?: {
      __typename?: "User";
      userId: string;
      locale?: string | null;
      activationState?: string | null;
      email: string;
      salutation: Salutation;
      firstName?: string | null;
      lastName: string;
      personalSapId?: string | null;
      addressDetails?: {
        __typename?: "AddressDetails";
        street: string;
        houseNumber: string;
        postalCode: string;
        city: string;
        country: string;
      } | null;
      bankDetails?: {
        __typename?: "BankDetails";
        accountOwner: string;
        iban: string;
        bic?: string | null;
      } | null;
      permissions: {
        __typename?: "Permissions";
        fbsUser: boolean;
        fbsUserCustomerIds: Array<string>;
        fleetAtHomeUser: boolean;
        fleetAtHomeUserCustomerId?: string | null;
        fleetAtHomeManager: boolean;
        fleetAtHomeManagerCustomerIds: Array<string>;
        preSalesManagerEquivolt: boolean;
        preSalesManagerEquivoltCustomerIds: Array<string>;
        gasStoreman: boolean;
        gasStoremanCustomerIds: Array<string>;
        gasRequester: boolean;
        gasRequesterCustomerIds: Array<string>;
        gasOci: boolean;
        gasOciCustomerIds: Array<string>;
        globalGasStoreman: boolean;
        globalGasStoremanCustomerIds: Array<string>;
        wccManager: boolean;
        wccManagerCustomerIds: Array<string>;
        wscManager: boolean;
        wscManagerCustomerIds: Array<string>;
        thgQuoteManager: boolean;
        thgQuoteManagerCustomerIds: Array<string>;
        virtaUser: boolean;
        virtaUserCustomerIds: Array<string>;
        gaasUser: boolean;
        gaasUserCustomerIds: Array<string>;
        westfalenIdAccountManager: boolean;
        westfalenIdAccountManagerCustomerIds: Array<string>;
        customers: Array<{
          __typename?: "Customer";
          id: string;
          name: string;
          name2?: string | null;
          customerNumber?: string | null;
          serviceSubscriptions: Array<ServiceSubscription>;
        }>;
      };
      capabilities: {
        __typename?: "UserCapabilities";
        canStoreAddressDetails: boolean;
        canStoreBankDetails: boolean;
      };
    } | null;
  };
};

export type GetCurrentUserFeatureFlagsQueryVariables = Exact<{
  customerId: Scalars["ID"]["input"];
}>;

export type GetCurrentUserFeatureFlagsQuery = {
  __typename?: "RootQueryType";
  currentUserFeatureFlags: Array<string>;
};

export type GetActiveNotificationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetActiveNotificationQuery = {
  __typename?: "RootQueryType";
  activeNotification?: {
    __typename?: "Notification";
    dateFrom: any;
    dateTo?: any | null;
    type: NotificationType;
    infoText?: string | null;
  } | null;
};

export type LogoutCurrentUserMutationVariables = Exact<{
  [key: string]: never;
}>;

export type LogoutCurrentUserMutation = {
  __typename?: "RootMutationType";
  logoutCurrentUser: {
    __typename?: "MutationResult";
    errors: Array<MutationError>;
    success: boolean;
  };
};

export type ThgQuoteVehicleClassesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ThgQuoteVehicleClassesQuery = {
  __typename?: "RootQueryType";
  thgQuoteVehicleClasses: Array<{
    __typename?: "ThgQuoteVehicleClassInfo";
    vehicleClass: string;
    description: string;
    price?: string | null;
    currency?: string | null;
  }>;
};

export type ThgQuotePendingVehicleRegistrationQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ThgQuotePendingVehicleRegistrationQuery = {
  __typename?: "RootQueryType";
  thgQuotePendingVehicleRegistration?: {
    __typename?: "ThgQuotePendingVehicleRegistration";
    externalId: string;
    vehicleClass: string;
    vehicleAlias?: string | null;
    vehicleCertificateFrontImageId: string;
    fin?: string | null;
  } | null;
};

export const UpdateBankDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateBankDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountOwner" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "iban" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bic" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateBankDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountOwner" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accountOwner" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "iban" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "iban" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bic" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bic" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateBankDetailsMutation,
  UpdateBankDetailsMutationVariables
>;
export const UpdateEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdatePasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdatePassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "password" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatePassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "password" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "password" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePasswordMutation,
  UpdatePasswordMutationVariables
>;
export const UpdateUserDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUserData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UserDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateUserData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserDataMutation,
  UpdateUserDataMutationVariables
>;
export const DeleteMyUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMyUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteMyUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteMyUserMutation,
  DeleteMyUserMutationVariables
>;
export const GetSupportCasesForUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSupportCasesForUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchString" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "supportCasesForUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "searchString" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchString" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateTo" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supportCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caseNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userFirstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userLastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "businessArea" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSupportCasesForUserQuery,
  GetSupportCasesForUserQueryVariables
>;
export const GetFleetAtHomeTransactionsForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeTransactionsForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isCredited" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startTime" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "StartTimeFilterInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "transactionsPage" },
            name: { kind: "Name", value: "fleetAtHomeTransactionsForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "isCredited" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "isCredited" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "startTime" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "startTime" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "userIds" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "userIds" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transactions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "creditState" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "energyAmountKilowatthours",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stopTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userName" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "salutation" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeTransactionsForCustomerQuery,
  GetFleetAtHomeTransactionsForCustomerQueryVariables
>;
export const GetFleetAtHomeUserNamesForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeUserNamesForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeUserNamesForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userName" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeUserNamesForCustomerQuery,
  GetFleetAtHomeUserNamesForCustomerQueryVariables
>;
export const GetFleetAtHomeActiveUsersKpiForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeActiveUsersKpiForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fleetAtHomeActiveUsersKpiForCustomer",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionsLastPeriod" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeActiveUsersKpiForCustomerQuery,
  GetFleetAtHomeActiveUsersKpiForCustomerQueryVariables
>;
export const GetFleetAtHomeChargesKpiForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeChargesKpiForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeChargesKpiForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "count" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "averagePreviousThreeMonths",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentMonth" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "averageEnergyAmountKilowatthours",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "averagePreviousThreeMonths",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentMonth" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentMonthProgress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentDay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalDays" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeChargesKpiForCustomerQuery,
  GetFleetAtHomeChargesKpiForCustomerQueryVariables
>;
export const GetFleetAtHomeCreditedAmountKpiForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "GetFleetAtHomeCreditedAmountKpiForCustomer",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fleetAtHomeCreditedAmountKpiForCustomer",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grossAmountInEuro" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "averagePreviousThreePeriods",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentPeriod" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentPeriodProgress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentDay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalDays" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeCreditedAmountKpiForCustomerQuery,
  GetFleetAtHomeCreditedAmountKpiForCustomerQueryVariables
>;
export const GetFleetAtHomeCurrentElectricityPriceKpiForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "GetFleetAtHomeCurrentElectricityPriceKpiForCustomer",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fleetAtHomeCurrentElectricityPriceKpiForCustomer",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "average" } },
                { kind: "Field", name: { kind: "Name", value: "minimum" } },
                { kind: "Field", name: { kind: "Name", value: "maximum" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeCurrentElectricityPriceKpiForCustomerQuery,
  GetFleetAtHomeCurrentElectricityPriceKpiForCustomerQueryVariables
>;
export const GetFleetAtHomeWallboxesKpiForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeWallboxesKpiForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeWallboxesKpiForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionsLastPeriod" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeWallboxesKpiForCustomerQuery,
  GetFleetAtHomeWallboxesKpiForCustomerQueryVariables
>;
export const FleetAtHomeUpdateCustomerSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FleetAtHomeUpdateCustomerSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerSettings" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FleetAtHomeCustomerSettingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeUpdateCustomerSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerSettings" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerSettings" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errorDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeUpdateCustomerSettingsMutation,
  FleetAtHomeUpdateCustomerSettingsMutationVariables
>;
export const GetFleetAtHomeCustomerSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeCustomerSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeCustomerSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "autoAcceptElectricityPrice" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityPriceRangeFrom" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityPriceRangeTo" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "companyIsPaying" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "electricityPriceCertificateNeeded",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityPriceVariants" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeCustomerSettingsQuery,
  GetFleetAtHomeCustomerSettingsQueryVariables
>;
export const FleetAtHomeAcceptProposedElectricityPriceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "FleetAtHomeAcceptProposedElectricityPrice",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fleetAtHomeAcceptProposedElectricityPrice",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "stationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeAcceptProposedElectricityPriceMutation,
  FleetAtHomeAcceptProposedElectricityPriceMutationVariables
>;
export const FleetAtHomeDeclineProposedElectricityPriceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {
        kind: "Name",
        value: "FleetAtHomeDeclineProposedElectricityPrice",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reason" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fleetAtHomeDeclineProposedElectricityPrice",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "stationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reason" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reason" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeDeclineProposedElectricityPriceMutation,
  FleetAtHomeDeclineProposedElectricityPriceMutationVariables
>;
export const GetFleetAtHomeUserDataForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeUserDataForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeUserDataForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrationLink" },
                },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "houseNumber" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "currentElectricityPrice",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "electricityPricePerKilowattHour",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "basicFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "state" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "dateTo" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "proposedElectricityPrice",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "electricityPricePerKilowattHour",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "basicFee" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "state" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "dateFrom" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeUserDataForCustomerQuery,
  GetFleetAtHomeUserDataForCustomerQueryVariables
>;
export const FleetAtHomeInviteUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FleetAtHomeInviteUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invitationData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InvitationDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeInviteUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invitationData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invitationData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "caseNumber" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeInviteUserMutation,
  FleetAtHomeInviteUserMutationVariables
>;
export const GetFleetAtHomeTransactionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeTransaction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeTransaction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
                { kind: "Field", name: { kind: "Name", value: "stopTime" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "energyAmountKilowatthours" },
                },
                { kind: "Field", name: { kind: "Name", value: "creditState" } },
                { kind: "Field", name: { kind: "Name", value: "isPrivate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "station" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "alias" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "houseNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "earliestPossibleElectricityPriceProposal",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "setupNecessary" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeTransactionQuery,
  GetFleetAtHomeTransactionQueryVariables
>;
export const GetFleetAtHomeTransactionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeTransactions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isPrivate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isCredited" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startTime" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateFilterInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "energyAmountKilowatthoursFrom" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Decimal" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "energyAmountKilowatthoursTo" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Decimal" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "amountFrom" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Decimal" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "amountTo" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Decimal" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeTransactions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "isPrivate" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "isPrivate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "isCredited" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "isCredited" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "startTime" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "startTime" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "energyAmountKilowatthoursFrom",
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "energyAmountKilowatthoursFrom",
                        },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "energyAmountKilowatthoursTo",
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "energyAmountKilowatthoursTo",
                        },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "amountFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "amountFrom" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "amountTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "amountTo" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalAmount" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "totalEnergyAmountKilowatthours",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalDurationMinutes" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transactions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "creditState" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "energyAmountKilowatthours",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stopTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isPrivate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "station" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "alias" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeTransactionsQuery,
  GetFleetAtHomeTransactionsQueryVariables
>;
export const GetFleetAtHomeCreditNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeCreditNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeCreditNote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dateFrom" } },
                { kind: "Field", name: { kind: "Name", value: "dateTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "energyAmountKilowatthours" },
                },
                { kind: "Field", name: { kind: "Name", value: "forecasted" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grossAmountInEuro" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfTransactions" },
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeCreditNoteQuery,
  GetFleetAtHomeCreditNoteQueryVariables
>;
export const GetFleetAtHomeCreditNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeCreditNotes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeCreditNotes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dateFrom" } },
                { kind: "Field", name: { kind: "Name", value: "dateTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "energyAmountKilowatthours" },
                },
                { kind: "Field", name: { kind: "Name", value: "forecasted" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grossAmountInEuro" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfTransactions" },
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeCreditNotesQuery,
  GetFleetAtHomeCreditNotesQueryVariables
>;
export const GetFleetAtHomeForecastedCreditNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeForecastedCreditNotes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeForecastedCreditNotes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dateFrom" } },
                { kind: "Field", name: { kind: "Name", value: "dateTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "energyAmountKilowatthours" },
                },
                { kind: "Field", name: { kind: "Name", value: "forecasted" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grossAmountInEuro" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfTransactions" },
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeForecastedCreditNotesQuery,
  GetFleetAtHomeForecastedCreditNotesQueryVariables
>;
export const GetFleetAtHomeChargesKpiDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeChargesKpi" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeChargesKpi" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "count" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "averagePreviousThreeMonths",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentMonth" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "averageEnergyAmountKilowatthours",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "averagePreviousThreeMonths",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentMonth" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentMonthProgress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentDay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalDays" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeChargesKpiQuery,
  GetFleetAtHomeChargesKpiQueryVariables
>;
export const GetFleetAtHomeCreditedAmountKpiDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeCreditedAmountKpi" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeCreditedAmountKpi" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "grossAmountInEuro" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "averagePreviousThreePeriods",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentPeriod" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentPeriodProgress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentDay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalDays" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeCreditedAmountKpiQuery,
  GetFleetAtHomeCreditedAmountKpiQueryVariables
>;
export const FleetAtHomeShopProductCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FleetAtHomeShopProductCategories" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeShopProductCategories" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeShopProductCategoriesQuery,
  FleetAtHomeShopProductCategoriesQueryVariables
>;
export const FleetAtHomeShopProductsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FleetAtHomeShopProducts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeShopProducts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detailedDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "listPrice" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mimeType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeShopProductsQuery,
  FleetAtHomeShopProductsQueryVariables
>;
export const FleetAtHomeOrderPreviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FleetAtHomeOrderPreview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FleetAtHomeOrderPreviewDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeOrderPreview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalAmount" } },
                { kind: "Field", name: { kind: "Name", value: "netAmount" } },
                { kind: "Field", name: { kind: "Name", value: "shipping" } },
                { kind: "Field", name: { kind: "Name", value: "vatAmount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isCompanyPaymentAllowed" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "price" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quantity" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeOrderPreviewQuery,
  FleetAtHomeOrderPreviewQueryVariables
>;
export const FleetAtHomePlaceOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FleetAtHomePlaceOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FleetAtHomeOrderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomePlaceOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomePlaceOrderMutation,
  FleetAtHomePlaceOrderMutationVariables
>;
export const FleetAtHomeShopProductDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FleetAtHomeShopProduct" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeShopProduct" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detailedDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "listPrice" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mimeType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "content" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "configurationOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortDescription" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "price" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listPrice" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "obligatoryConfigurationOptions",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortDescription" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "price" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listPrice" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shortDescription" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "price" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "listPrice" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeShopProductQuery,
  FleetAtHomeShopProductQueryVariables
>;
export const FleetAtHomeProposeElectricityPriceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FleetAtHomeProposeElectricityPrice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "electricityPricePerKilowattHour" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Decimal" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "basicFee" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Decimal" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "electricityPriceCertificateId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeProposeElectricityPrice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateFrom" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateFrom" },
                },
              },
              {
                kind: "Argument",
                name: {
                  kind: "Name",
                  value: "electricityPricePerKilowattHour",
                },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "electricityPricePerKilowattHour",
                  },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "basicFee" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "basicFee" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "stationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "electricityPriceCertificateId" },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "electricityPriceCertificateId",
                  },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeProposeElectricityPriceMutation,
  FleetAtHomeProposeElectricityPriceMutationVariables
>;
export const FleetAtHomeUpdateStationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FleetAtHomeUpdateStation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "alias" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "street" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "houseNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "city" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "postalCode" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "country" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "flatrateSettlementConditionId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "flatrateSettlementIsActive" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeUpdateStation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "stationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "alias" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "alias" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "street" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "street" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "houseNumber" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "houseNumber" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "city" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "city" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "postalCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "postalCode" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "country" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "country" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "flatrateSettlementConditionId" },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "flatrateSettlementConditionId",
                  },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "flatrateSettlementIsActive" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "flatrateSettlementIsActive" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errorDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeUpdateStationMutation,
  FleetAtHomeUpdateStationMutationVariables
>;
export const FleetAtHomeWithdrawElectricityPriceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FleetAtHomeWithdrawElectricityPrice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fleetAtHomeWithdrawProposedElectricityPrice",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "stationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FleetAtHomeWithdrawElectricityPriceMutation,
  FleetAtHomeWithdrawElectricityPriceMutationVariables
>;
export const GetFleetAtHomeElectricityPriceHistoryForStationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "GetFleetAtHomeElectricityPriceHistoryForStation",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "stationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fleetAtHomeElectricityPriceHistoryForStation",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "stationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "dateFrom" } },
                { kind: "Field", name: { kind: "Name", value: "dateTo" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "electricityPricePerKilowattHour",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "basicFee" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                { kind: "Field", name: { kind: "Name", value: "reason" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeElectricityPriceHistoryForStationQuery,
  GetFleetAtHomeElectricityPriceHistoryForStationQueryVariables
>;
export const GetFleetAtHomeFlatrateElectricityPriceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeFlatrateElectricityPrice" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fleetAtHomeFlatrateElectricityPrice",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dateFrom" } },
                { kind: "Field", name: { kind: "Name", value: "dateTo" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "electricityPricePerKilowattHour",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "conditionId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeFlatrateElectricityPriceQuery,
  GetFleetAtHomeFlatrateElectricityPriceQueryVariables
>;
export const GetFleetAtHomeStationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFleetAtHomeStations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fleetAtHomeStations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "setupNecessary" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "alias" } },
                { kind: "Field", name: { kind: "Name", value: "street" } },
                { kind: "Field", name: { kind: "Name", value: "houseNumber" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "earliestPossibleElectricityPriceProposal",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentElectricityPrice" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "electricityPricePerKilowattHour",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basicFee" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "proposedElectricityPrice" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "electricityPricePerKilowattHour",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "basicFee" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reason" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoiceUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "netAmount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trackingNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "vatAmount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFleetAtHomeStationsQuery,
  GetFleetAtHomeStationsQueryVariables
>;
export const FinishRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FinishRegistration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "address" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AddressInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "finishRegistration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "address" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "address" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FinishRegistrationMutation,
  FinishRegistrationMutationVariables
>;
export const GetActiveMaintenanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActiveMaintenance" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activeMaintenance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dateFrom" } },
                { kind: "Field", name: { kind: "Name", value: "dateTo" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActiveMaintenanceQuery,
  GetActiveMaintenanceQueryVariables
>;
export const CustomerManagementRegisterInvitedUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CustomerManagementRegisterInvitedUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "registrationData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CustomerManagementRegistrationDataInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "customerManagementRegisterInvitedUser",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "registrationData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "caseNumber" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrationFinished" },
                },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerManagementRegisterInvitedUserMutation,
  CustomerManagementRegisterInvitedUserMutationVariables
>;
export const GetRegistrationDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRegistrationData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provisioningKey" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "registrationType" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RegistrationType" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registrationData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "provisioningKey" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provisioningKey" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "registrationType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrationData" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "finishedRegistration" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRegistrationDataQuery,
  GetRegistrationDataQueryVariables
>;
export const RegisterFleetAtHomeUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RegisterFleetAtHomeUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "registrationData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FleetAtHomeRegistrationDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerFleetAtHomeUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "registrationData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "passwordSet" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterFleetAtHomeUserMutation,
  RegisterFleetAtHomeUserMutationVariables
>;
export const RegisterExistingCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RegisterExistingCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "registrationData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RegisterExistingCustomerInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerExistingCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "registrationData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "caseNumber" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterExistingCustomerMutation,
  RegisterExistingCustomerMutationVariables
>;
export const RegisterUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RegisterUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "registrationData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RegistrationDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "registrationData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterUserMutation,
  RegisterUserMutationVariables
>;
export const VerifyEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "VerifyEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "token" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "password" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "token" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "token" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "password" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "password" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "passwordSet" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const ThgQuotePreregisterVehicleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ThgQuotePreregisterVehicle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ThgQuotePendingVehicleRegistrationInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "thgQuotePreregisterVehicle" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pendingVehicleRegistrationId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ThgQuotePreregisterVehicleMutation,
  ThgQuotePreregisterVehicleMutationVariables
>;
export const GetThgQuoteVehicleRegistrationsForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "GetThgQuoteVehicleRegistrationsForCustomer",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "thgQuoteVehicleRegistrationsForCustomer",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vehicleAlias" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vehicleClass" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vehicleOwner" },
                },
                { kind: "Field", name: { kind: "Name", value: "year" } },
                { kind: "Field", name: { kind: "Name", value: "fin" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "validForResubmission" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetThgQuoteVehicleRegistrationsForCustomerQuery,
  GetThgQuoteVehicleRegistrationsForCustomerQueryVariables
>;
export const ThgQuoteResubmitVehicleRegistrationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ThgQuoteResubmitVehicleRegistrations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "applicationIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "thgQuoteResubmitVehicleRegistrations",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "applicationIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "results" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ThgQuoteResubmitVehicleRegistrationsMutation,
  ThgQuoteResubmitVehicleRegistrationsMutationVariables
>;
export const ThgQuoteDeletePendingVehicleRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ThgQuoteDeletePendingVehicleRegistration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "thgQuoteDeletePendingVehicleRegistration",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ThgQuoteDeletePendingVehicleRegistrationMutation,
  ThgQuoteDeletePendingVehicleRegistrationMutationVariables
>;
export const ThgQuoteRegisterVehicleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ThgQuoteRegisterVehicle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ThgQuoteVehicleRegistrationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "thgQuoteRegisterVehicle" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ThgQuoteRegisterVehicleMutation,
  ThgQuoteRegisterVehicleMutationVariables
>;
export const ThgQuoteVehicleRegistrationInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ThgQuoteVehicleRegistrationInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "thgQuoteVehicleRegistrationInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "addressDetailsNecessary" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "vatIdentificationNumberNecessary",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ThgQuoteVehicleRegistrationInfoQuery,
  ThgQuoteVehicleRegistrationInfoQueryVariables
>;
export const WccReactivateCardsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WccReactivateCards" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNumbers" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccReactivateCards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNumbers" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNumbers" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WccReactivateCardsMutation,
  WccReactivateCardsMutationVariables
>;
export const ActivateCardSubscriptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "activateCardSubscriptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardSubscriptions" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "WccCardSubscriptionInput" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccActivateCardSubscriptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardSubscriptions" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardSubscriptions" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActivateCardSubscriptionsMutation,
  ActivateCardSubscriptionsMutationVariables
>;
export const WccChargeCardsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WccChargeCards" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardCharges" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "WccCardChargeInput" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccChargeCards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardCharges" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardCharges" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WccChargeCardsMutation,
  WccChargeCardsMutationVariables
>;
export const GetWccChargeHistoryForCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWccChargeHistoryForCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNr" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccChargeHistoryForCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNr" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNr" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "charges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargedAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isCancelable" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWccChargeHistoryForCardQuery,
  GetWccChargeHistoryForCardQueryVariables
>;
export const DeactivateCardSubscriptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deactivateCardSubscriptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNumbers" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccDeactivateCardSubscriptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNumbers" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNumbers" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeactivateCardSubscriptionsMutation,
  DeactivateCardSubscriptionsMutationVariables
>;
export const WccDeactivateCardsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WccDeactivateCards" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNumbers" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccDeactivateCards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNumbers" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNumbers" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WccDeactivateCardsMutation,
  WccDeactivateCardsMutationVariables
>;
export const WccPlaceCardOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WccPlaceCardOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WccOrderDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccPlaceCardOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WccPlaceCardOrderMutation,
  WccPlaceCardOrderMutationVariables
>;
export const WccUpdateCardLabelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WccUpdateCardLabels" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardLabels" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "WccCardLabelInput" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccUpdateCardLabels" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardLabels" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardLabels" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WccUpdateCardLabelsMutation,
  WccUpdateCardLabelsMutationVariables
>;
export const WccUpdateCardSubscriptionAmountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WccUpdateCardSubscriptionAmounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardSubscriptions" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "WccCardSubscriptionInput" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccUpdateCardSubscriptionAmounts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardSubscriptions" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardSubscriptions" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WccUpdateCardSubscriptionAmountsMutation,
  WccUpdateCardSubscriptionAmountsMutationVariables
>;
export const WccUpdateCardSubscriptionTermsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WccUpdateCardSubscriptionTerms" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardSubscriptionTerms" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "WccCardSubscriptionTermInput" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccUpdateCardSubscriptionTerms" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardSubscriptionTerms" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardSubscriptionTerms" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WccUpdateCardSubscriptionTermsMutation,
  WccUpdateCardSubscriptionTermsMutationVariables
>;
export const GetWccChargeHistoryForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWccChargeHistoryForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchString" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "types" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "WccChargeType" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "amountFrom" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Decimal" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "amountTo" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Decimal" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccChargeHistoryForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "searchString" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchString" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateTo" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "types" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "types" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "amountFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "amountFrom" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "amountTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "amountTo" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "charges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargedAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isCancelable" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadLink" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWccChargeHistoryForCustomerQuery,
  GetWccChargeHistoryForCustomerQueryVariables
>;
export const GetWccInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWccInvoice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccInvoice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "invoicedAt" } },
                { kind: "Field", name: { kind: "Name", value: "netValue" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documentAvailable" },
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWccInvoiceQuery, GetWccInvoiceQueryVariables>;
export const GetWccInvoicesForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWccInvoicesForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccInvoicesForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateTo" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invoices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoicedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "netValue" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentAvailable" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWccInvoicesForCustomerQuery,
  GetWccInvoicesForCustomerQueryVariables
>;
export const GetWccOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWccOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "orderNumber" } },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batch1" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardQuantity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscriptionAmount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batch2" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardQuantity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscriptionAmount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batch3" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardQuantity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscriptionAmount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cards" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archivedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastChargedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reloadCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscriptionAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscriptionState" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmountPerPeriod" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWccOrderQuery, GetWccOrderQueryVariables>;
export const GetWccOrdersForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWccOrdersForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchString" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "states" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "WccOrderState" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccOrdersForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "searchString" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchString" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateTo" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "states" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "states" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "orders" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orderNumber" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "batch1" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cardQuantity" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "subscriptionAmount",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "batch2" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cardQuantity" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "subscriptionAmount",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "batch3" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cardQuantity" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "subscriptionAmount",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWccOrdersForCustomerQuery,
  GetWccOrdersForCustomerQueryVariables
>;
export const GetWccCardsForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWccCardsForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchString" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "state" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WccCardState" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "subscriptionStates" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "WccSubscriptionState" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortParams" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WccCardSortInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccCardsForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "searchString" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchString" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "subscriptionStates" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "subscriptionStates" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "state" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "state" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortParams" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortParams" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cards" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "archivedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastChargedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reloadCount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscriptionAmount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscriptionState" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subscriptionActiveFrom" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "subscriptionActiveUntil",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalAmountPerPeriod" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "orderId" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWccCardsForCustomerQuery,
  GetWccCardsForCustomerQueryVariables
>;
export const WccCancelCardChargesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WccCancelCardCharges" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNumbers" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wccCancelCardCharges" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNumbers" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNumbers" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardResults" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "error" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WccCancelCardChargesMutation,
  WccCancelCardChargesMutationVariables
>;
export const CustomerManagementGenerateInvitationLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CustomerManagementGenerateInvitationLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serviceRoles" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ServiceRole" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "maximumRegistrations" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "validUntil" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTime" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "needsReview" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "customerManagementGenerateInvitationLink",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "name" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "name" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "serviceRoles" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serviceRoles" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "maximumRegistrations" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "maximumRegistrations" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "validUntil" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "validUntil" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "needsReview" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "needsReview" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitationLink" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerManagementGenerateInvitationLinkMutation,
  CustomerManagementGenerateInvitationLinkMutationVariables
>;
export const GetInvitationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getInvitations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerManagementInvitations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maximumRegistrations" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "validUntil" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invitationLink" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "needsReview" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registrations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "salutation" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "caseNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedAt" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "servicesWithRoles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "serviceRoles" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetInvitationsQuery, GetInvitationsQueryVariables>;
export const CustomerManagementReviewRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CustomerManagementReviewRegistration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "registrationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reviewOutcome" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "CustomerManagementRegistrationReviewOptions",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "customerManagementReviewRegistration",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "registrationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "registrationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reviewOutcome" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reviewOutcome" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "caseNumber" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerManagementReviewRegistrationMutation,
  CustomerManagementReviewRegistrationMutationVariables
>;
export const CustomerManagementUpdateInvitationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CustomerManagementUpdateInvitation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invitationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updateData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateInvitationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerManagementUpdateInvitation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "invitationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invitationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updateData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerManagementUpdateInvitationMutation,
  CustomerManagementUpdateInvitationMutationVariables
>;
export const GetCustomerManagementCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCustomerManagementCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerManagementCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "name2" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customerNumber" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "serviceSubscriptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serviceRoles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCustomerManagementCustomerQuery,
  GetCustomerManagementCustomerQueryVariables
>;
export const CustomerManagementSupportCasesForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "CustomerManagementSupportCasesForCustomer",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchString" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "customerManagementSupportCasesForCustomer",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "searchString" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchString" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateTo" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supportCases" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "caseNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userFirstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userLastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customerName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "businessArea" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerManagementSupportCasesForCustomerQuery,
  CustomerManagementSupportCasesForCustomerQueryVariables
>;
export const CustomerManagementInviteUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CustomerManagementInviteUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invitationData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InvitationDataInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serviceRoles" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ServiceRole" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customerManagementInviteUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invitationData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invitationData" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "serviceRoles" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serviceRoles" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitationResult" },
                },
                { kind: "Field", name: { kind: "Name", value: "caseNumber" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerManagementInviteUserMutation,
  CustomerManagementInviteUserMutationVariables
>;
export const CustomerManagementUpdateUserPermissionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CustomerManagementUpdateUserPermissions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serviceRoles" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ServiceRole" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "customerManagementUpdateUserPermissions",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "serviceRoles" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serviceRoles" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CustomerManagementUpdateUserPermissionsMutation,
  CustomerManagementUpdateUserPermissionsMutationVariables
>;
export const GetCustomerManagementUserDataForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCustomerManagementUserDataForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchString" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "states" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "CustomerManagementUserState" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "services" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ServiceSubscription" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "customerManagementUserDataForCustomer",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "searchString" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchString" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "states" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "states" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "services" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "services" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userData" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registrationLink" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "servicesWithRoles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "serviceRoles" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCustomerManagementUserDataForCustomerQuery,
  GetCustomerManagementUserDataForCustomerQueryVariables
>;
export const GetWscCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWscCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNr" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNr" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNr" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptanceType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalText" },
                },
                { kind: "Field", name: { kind: "Name", value: "bookingText" } },
                { kind: "Field", name: { kind: "Name", value: "cardNr" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "decryptedCardPin" },
                },
                { kind: "Field", name: { kind: "Name", value: "costCenter" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityCardEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "electricityCardInformation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gasStationId" },
                },
                { kind: "Field", name: { kind: "Name", value: "gasStation" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "licensePlate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissionLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissionProductIds" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestInfoEntry" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requestKilometresEntry" },
                },
                { kind: "Field", name: { kind: "Name", value: "state" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxTransactionsPerDay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "virtualCardEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "futureBlockDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "virtualCardInformation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appIdentification" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternativeShippingAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addition" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "usedSalesVolumeInCurrentBillingPeriod",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "openSalesVolumeInCurrentBillingPeriod",
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "salesLimitPerBillingPeriod",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "shippingAddress" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "addition" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "street" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWscCardQuery, GetWscCardQueryVariables>;
export const GetWscCardPermissionProductsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWscCardPermissionProducts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "lang" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscCardPermissionProducts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "lang" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lang" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWscCardPermissionProductsQuery,
  GetWscCardPermissionProductsQueryVariables
>;
export const GetWscCardsForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWscCardsForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchString" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardStates" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "WscCardState" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "individualPermissionIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscCardsForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "searchString" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchString" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "states" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "cardStates" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "individualPermissionIds" },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "individualPermissionIds",
                        },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cards" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "acceptanceType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "additionalText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bookingText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "costCenter" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "electricityCardEnabled" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "electricityCardInformation",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiresAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gasStation" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "licensePlate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissionLevel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissionProductIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestInfoEntry" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestKilometresEntry" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxTransactionsPerDay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "virtualCardEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "virtualCardInformation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "appIdentification",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contactType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "phoneNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "salutation" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadLink" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWscCardsForCustomerQuery,
  GetWscCardsForCustomerQueryVariables
>;
export const WscDeactivatedCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WscDeactivatedCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNr" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "futureBlockDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscDeactivateCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNr" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNr" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "futureBlockDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "futureBlockDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WscDeactivatedCardMutation,
  WscDeactivatedCardMutationVariables
>;
export const WscPlaceCardOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WscPlaceCardOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WscOrderDataInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscPlaceCardOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WscPlaceCardOrderMutation,
  WscPlaceCardOrderMutationVariables
>;
export const WscReplaceCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WscReplaceCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNr" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "replacementType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WscReplacementType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "alternativeShippingAddress" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "WscAddressInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscPlaceReplacementCardOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNr" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNr" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "replacementCardOrderData" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "replacementType" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "replacementType" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "alternativeShippingAddress",
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "alternativeShippingAddress",
                        },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WscReplaceCardMutation,
  WscReplaceCardMutationVariables
>;
export const WscRevokeFutureCardDeactivationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WscRevokeFutureCardDeactivation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNr" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscRevokeFutureCardDeactivation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNr" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNr" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WscRevokeFutureCardDeactivationMutation,
  WscRevokeFutureCardDeactivationMutationVariables
>;
export const WscSendVirtualCardActivationLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "wscSendVirtualCardActivationLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNr" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscSendVirtualCardActivationLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNr" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNr" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WscSendVirtualCardActivationLinkMutation,
  WscSendVirtualCardActivationLinkMutationVariables
>;
export const GetWscStationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWscStations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscStations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWscStationsQuery, GetWscStationsQueryVariables>;
export const WscUpdateCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WscUpdateCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardNr" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updateCardData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "WscCardUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscUpdateCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardNr" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardNr" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateCardData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updateCardData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WscUpdateCardMutation,
  WscUpdateCardMutationVariables
>;
export const GetWscInvoiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWscInvoice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "invoiceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscInvoice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "invoiceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "invoiceId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "invoicedAt" } },
                { kind: "Field", name: { kind: "Name", value: "grossValue" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documentAvailable" },
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWscInvoiceQuery, GetWscInvoiceQueryVariables>;
export const GetWscInvoicesForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWscInvoicesForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchString" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscInvoicesForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateTo" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "searchString" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchString" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invoices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoicedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "grossValue" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documentAvailable" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWscInvoicesForCustomerQuery,
  GetWscInvoicesForCustomerQueryVariables
>;
export const GetWscIndividualCustomerPermissionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWscIndividualCustomerPermissions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeUsageData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscIndividualCustomerPermissions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permissionProductIds" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usageCount" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "includeUsageData" },
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWscIndividualCustomerPermissionsQuery,
  GetWscIndividualCustomerPermissionsQueryVariables
>;
export const WscCreateIndividualCustomerPermissionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WscCreateIndividualCustomerPermission" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "permissionData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "WscIndividualCustomerPermissionCreateInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "wscCreateIndividualCustomerPermission",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "permissionData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "permissionData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WscCreateIndividualCustomerPermissionMutation,
  WscCreateIndividualCustomerPermissionMutationVariables
>;
export const WscDeleteIndividualCustomerPermissionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WscDeleteIndividualCustomerPermission" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "permissionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "wscDeleteIndividualCustomerPermission",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "permissionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "permissionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WscDeleteIndividualCustomerPermissionMutation,
  WscDeleteIndividualCustomerPermissionMutationVariables
>;
export const WscUpdateIndividualCustomerPermissionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WscUpdateIndividualCustomerPermission" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "permissionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updatePermissionData" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "WscIndividualCustomerPermissionUpdateInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "wscUpdateIndividualCustomerPermission",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "permissionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "permissionId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "updatePermissionData" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updatePermissionData" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WscUpdateIndividualCustomerPermissionMutation,
  WscUpdateIndividualCustomerPermissionMutationVariables
>;
export const GetWscCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWscCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "usedSalesVolumeInCurrentBillingPeriod",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "openSalesVolumeInCurrentBillingPeriod",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "salesLimitPerBillingPeriod" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shippingAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addition" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWscCustomerQuery, GetWscCustomerQueryVariables>;
export const GetWscTransactionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWscTransaction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "transactionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscTransaction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "transactionId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "transactionId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "receiptNr" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "gasStation" } },
                { kind: "Field", name: { kind: "Name", value: "street" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "goodsGroup" } },
                { kind: "Field", name: { kind: "Name", value: "quantity" } },
                { kind: "Field", name: { kind: "Name", value: "unit" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "grossValue" } },
                { kind: "Field", name: { kind: "Name", value: "mileage" } },
                { kind: "Field", name: { kind: "Name", value: "info" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "card" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "acceptanceType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "additionalText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bookingText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardNr" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "costCenter" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "decryptedCardPin" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "electricityCardEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiresAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gasStation" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "licensePlate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissionLevel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissionProductIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestInfoEntry" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestKilometresEntry" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxTransactionsPerDay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "virtualCardEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "virtualCardInformation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "appIdentification",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contactType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "phoneNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "salutation" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "alternativeShippingAddress",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "addition" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "street" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWscTransactionQuery,
  GetWscTransactionQueryVariables
>;
export const GetWscGoodsGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWscGoodsGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscGoodsGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWscGoodsGroupsQuery,
  GetWscGoodsGroupsQueryVariables
>;
export const GetWscTransactionsForCustomerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getWscTransactionsForCustomer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchString" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "goodsGroups" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "grossValueFrom" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Decimal" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "grossValueTo" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Decimal" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wscTransactionsForCustomer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filterParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dateTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateTo" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "searchString" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchString" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "goodsGroups" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "goodsGroups" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "grossValueFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "grossValueFrom" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "grossValueTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "grossValueTo" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paginationParams" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "pageSize" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pageSize" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transactions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactionCardData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cardNr" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gasStation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postalCode" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quantity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "goodsGroup" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "grossValue" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "unit" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paginationMetadata" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEntries" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "downloadLink" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWscTransactionsForCustomerQuery,
  GetWscTransactionsForCustomerQueryVariables
>;
export const ClearCurrentUserCachedPermissionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ClearCurrentUserCachedPermissions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clearCurrentUserCachedPermissions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClearCurrentUserCachedPermissionsMutation,
  ClearCurrentUserCachedPermissionsMutationVariables
>;
export const GetCurrentUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCurrentUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUserV2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locale" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activationState" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salutation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "personalSapId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "addressDetails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "street" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "houseNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "postalCode" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bankDetails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accountOwner" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "iban" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "bic" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fbsUser" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fbsUserCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fleetAtHomeUser" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fleetAtHomeUserCustomerId",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fleetAtHomeManager",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "fleetAtHomeManagerCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "preSalesManagerEquivolt",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "preSalesManagerEquivoltCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gasStoreman" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "gasStoremanCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gasRequester" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "gasRequesterCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gasOci" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "gasOciCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "globalGasStoreman",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "globalGasStoremanCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "wccManager" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "wccManagerCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "wscManager" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "wscManagerCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thgQuoteManager" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "thgQuoteManagerCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "virtaUser" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "virtaUserCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gaasUser" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "gaasUserCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "westfalenIdAccountManager",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "westfalenIdAccountManagerCustomerIds",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customers" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name2" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "customerNumber",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "serviceSubscriptions",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "capabilities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "canStoreAddressDetails",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "canStoreBankDetails",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetCurrentUserFeatureFlagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCurrentUserFeatureFlags" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUserFeatureFlags" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "customerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "customerId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCurrentUserFeatureFlagsQuery,
  GetCurrentUserFeatureFlagsQueryVariables
>;
export const GetActiveNotificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActiveNotification" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activeNotification" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dateFrom" } },
                { kind: "Field", name: { kind: "Name", value: "dateTo" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "infoText" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActiveNotificationQuery,
  GetActiveNotificationQueryVariables
>;
export const LogoutCurrentUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LogoutCurrentUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "logoutCurrentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "errors" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LogoutCurrentUserMutation,
  LogoutCurrentUserMutationVariables
>;
export const ThgQuoteVehicleClassesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ThgQuoteVehicleClasses" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "thgQuoteVehicleClasses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vehicleClass" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ThgQuoteVehicleClassesQuery,
  ThgQuoteVehicleClassesQueryVariables
>;
export const ThgQuotePendingVehicleRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ThgQuotePendingVehicleRegistration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "thgQuotePendingVehicleRegistration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "externalId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vehicleClass" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vehicleAlias" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "vehicleCertificateFrontImageId",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "fin" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ThgQuotePendingVehicleRegistrationQuery,
  ThgQuotePendingVehicleRegistrationQueryVariables
>;
